<template>
  <div v-if="!isLoadingPage">
    <div v-if="permission !== null">
      <div v-if="permission.read_perm == 1">
        <v-card elevation="0" class="outer-card">
          <v-card-title>
            <p
              class="text-h6 font-weight-bold text-center text-uppercase"
              style="margin: auto"
            >
              Detail {{ detailData ? detailData.name : 'Dokumen Audit' }}
              <v-tooltip bottom color="grey">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    x-small
                    text
                    icon
                    color="grey darken-2"
                    @click="getDataFromApi"
                    style="position: relative; top: -3px"
                  >
                    <v-icon small>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>refresh page</span>
              </v-tooltip>
            </p>
            <p v-if="detailData" class="doc-no">
              {{ detailData.audit_no }}
            </p>
          </v-card-title>
          <div class="actionButton">
            <v-btn
              type="button"
              rounded
              elevation="0"
              class="font-weight-bold ma-2"
              @click.prevent="closeDetailAudit"
              outlined
              x-small
            >
              <v-icon x-small>mdi-chevron-left</v-icon>
              Kembali
            </v-btn>
            <div class="status-label">
              <p
                v-if="detailData"
                class="status-text"
                :style="`background-color: ${statusColor(detailData.status)};`"
              >
                {{ detailData.status.name }}
              </p>
            </div>
          </div>
        </v-card>
        <v-card elevation="0" v-if="detailData != null">
          <v-card-text>
            <p class="created-text">
              Tgl. Buat: {{ detailData.created_at }} |
              {{ detailData.created_by_name }}
            </p>
            <v-form
              ref="entryForm"
              :readonly="!isEdit"
              @submit.prevent="saveForm"
              style="margin-top: 10px"
            >
              <div>
                <v-row>
                  <v-col cols="12" md="4" class="d-flex flex-column">
                    <p class="text-left column-label">Perusahaan</p>
                    <v-autocomplete
                      v-model="detailData.company"
                      :items="dropdown.company"
                      :rules="rules.companyRules"
                      item-text="name"
                      item-value="id"
                      return-object
                      dense
                      :outlined="isEdit"
                      :clearable="isEdit"
                      style="height: 45px"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="3" class="d-flex flex-column">
                    <p class="text-left column-label">Tipe Audit</p>
                    <v-autocomplete
                      v-model="detailData.audit_type"
                      :items="dropdown.auditType"
                      :rules="rules.typeRules"
                      item-text="name"
                      item-value="id"
                      return-id
                      dense
                      :outlined="isEdit"
                      :clearable="isEdit"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="2" class="d-flex flex-column">
                    <p class="text-left column-label">Tgl. Audit</p>
                    <v-text-field
                      v-model="detailData.audit_date"
                      dense
                      :outlined="isEdit"
                      :clearable="isEdit"
                      style="height: 45px"
                    />
                  </v-col>

                  <v-col cols="12" md="9" class="d-flex flex-column">
                    <p class="text-left column-label">Template</p>
                    <v-autocomplete
                      v-model="detailData.template"
                      :items="dropdown.template"
                      :rules="rules.templateRules"
                      item-text="name"
                      item-value="id"
                      return-object
                      dense
                      :outlined="isEdit"
                      :clearable="isEdit"
                    ></v-autocomplete>
                  </v-col>
                  <v-col
                    v-if="detailData.status.id == 4"
                    cols="9"
                    class="d-flex flex-column"
                  >
                    <p class="text-left column-label">Alasan Cancel</p>
                    <v-text-field
                      v-model="detailData.cancel_note"
                      rows="1"
                      :auto-grow="true"
                    />
                  </v-col>
                </v-row>
              </div>
              <v-card-actions
                v-if="
                  getUserProfile.level.find(
                    ({ id }) =>
                      id == appLevel.adminAudit || id == appLevel.administrator
                  ) != undefined
                "
              >
                <div v-if="!isEdit" class="action-button-1">
                  <div v-if="detailData.status.id == 0">
                    <v-btn
                      style="font-weight: bold"
                      x-small
                      text
                      outlined
                      color="primary"
                      @click.prevent="enableEdit"
                    >
                      <v-icon x-small color="primary" class="icon-position">
                        mdi-pencil
                      </v-icon>
                      Edit Header
                    </v-btn>
                    <v-btn
                      class="button-status"
                      x-small
                      text
                      outlined
                      color="success"
                      @click="submitAuditDocument"
                    >
                      SUBMIT
                    </v-btn>
                    <v-btn
                      class="button-status"
                      x-small
                      text
                      outlined
                      color="red"
                      @click="cancelAuditDocument"
                    >
                      CANCEL
                    </v-btn>
                  </div>
                  <div v-if="detailData.status.id == 1">
                    <div
                      v-if="
                        isAllowApprove &&
                        detailData.approver_ids.find(
                          (val) => val == getUserProfile.employee.id
                        ) != undefined
                      "
                    >
                      <v-btn
                        class="button-status"
                        x-small
                        text
                        outlined
                        color="success"
                        @click="confirmAuditDocument"
                      >
                        CONFIRM
                      </v-btn>
                      <v-btn
                        class="button-status"
                        x-small
                        text
                        outlined
                        color="red"
                        @click="rejectAuditDocument"
                      >
                        REJECT
                      </v-btn>
                    </div>
                  </div>
                  <div v-if="detailData.status.id == 2">
                    <v-btn
                      class="button-status"
                      x-small
                      text
                      outlined
                      color="success"
                      @click="doneAuditDocument"
                    >
                      DONE
                    </v-btn>
                    <v-btn
                      class="button-status"
                      x-small
                      text
                      outlined
                      color="red"
                      @click="cancelAuditDocument"
                    >
                      CANCEL
                    </v-btn>
                  </div>
                  <div
                    v-if="
                      detailData.status.id == 4 || detailData.status.id == 5
                    "
                  >
                    <v-btn
                      class="button-status"
                      x-small
                      text
                      outlined
                      color="primary"
                      @click="setDraftAuditDocument"
                    >
                      SET DRAFT
                    </v-btn>
                  </div>
                </div>

                <div v-else class="action-button-2">
                  <v-btn
                    class="font-bold"
                    x-small
                    text
                    outlined
                    color="primary"
                    type="submit"
                  >
                    <v-icon x-small color="primary" class="icon-position">
                      mdi-content-save-edit-outline
                    </v-icon>
                    Save
                  </v-btn>
                  <v-btn
                    class="button-cancel"
                    x-small
                    text
                    outlined
                    color="red"
                    @click="enableEdit"
                  >
                    <v-icon x-small color="red" class="icon-position">
                      mdi-cancel
                    </v-icon>
                    Cancel
                  </v-btn>
                </div>
              </v-card-actions>
              <!-- <v-divider></v-divider> -->
            </v-form>
          </v-card-text>
          <!-- v-if="
                detailData.form_template_item != null &&
                detailData.form_template_item.lenght > 0
              "
             -->
          <v-card-text>
            <v-card v-if="!loading">
              <v-tabs
                v-model="tab"
                background-color="#ccdbdc"
                slider-color="primary"
              >
                <v-tab v-for="item in tabItems" :key="item.tab">
                  {{ item.tab }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item
                  v-for="item in tabItems"
                  :key="item.tab"
                  style="padding: 10px"
                >
                  <div style="min-height: 70vh; padding: 0">
                    <div
                      v-if="item.tab == 'Form Audit'"
                      style="padding-top: 10px"
                    >
                      <div class="position-relative z-0">
                        <v-btn
                          v-if="
                            !isEdit &&
                            detailData.status.id == 0 &&
                            getUserProfile.level.find(
                              ({ id }) =>
                                id == appLevel.adminAudit ||
                                id == appLevel.administrator
                            ) != undefined
                          "
                          color="blue darken-1"
                          type="button"
                          small
                          outlined
                          class="white--text"
                          style="
                            position: absolute;
                            top: 0px;
                            right: 0px;
                            z-index: 3;
                          "
                          @click="regenerateForm"
                        >
                          Regenerate Form
                        </v-btn>
                        <div
                          style="
                            position: relative;
                            top: 0px;
                            left: 0;
                            z-index: 2;
                            display: flex;
                          "
                        >
                          <div
                            style="
                              width: 140px;
                              height: 45px;
                              margin-right: 15px;
                            "
                          >
                            <v-autocomplete
                              v-model="actionValue"
                              :disabled="selectedData.length === 0"
                              :items="itemsAction"
                              @change="actionSelect"
                              label="Action"
                              item-text="name"
                              item-value="id"
                              return-id
                              dense
                              outlined
                            ></v-autocomplete>
                          </div>
                          <div
                            v-if="detailData.audit_type.id == 2"
                            style="width: 210px; height: 45px"
                          >
                            <v-autocomplete
                              v-model="paramAPI.area"
                              :items="dropdown.area"
                              @change="areaWatcher"
                              label="Area"
                              item-text="name"
                              item-value="id"
                              return-id
                              dense
                              outlined
                              clearable
                            ></v-autocomplete>
                          </div>
                          <div
                            v-if="detailData.audit_type.id == 1"
                            style="width: 210px; height: 45px"
                          >
                            <v-autocomplete
                              v-model="paramAPI.scope"
                              :items="dropdown.scope"
                              @change="scopeWatcher"
                              label="Scope"
                              item-text="name"
                              item-value="id"
                              return-id
                              dense
                              outlined
                              clearable
                            ></v-autocomplete>
                          </div>
                        </div>
                      </div>
                      <v-card v-if="scoreItem != null" elevation="3">
                        <v-tabs
                          v-model="locationTab"
                          background-color="#ccdbdc"
                          slider-color="primary"
                          color="primary"
                          class="mt-5"
                          vertical
                        >
                          <v-tab
                            v-for="itemLocation in locationTabItems"
                            :key="itemLocation.tab"
                          >
                            {{ itemLocation.tab }}
                          </v-tab>
                          <v-tabs-items v-model="locationTab">
                            <v-tab-item
                              v-for="itemLocation in locationTabItems"
                              :key="itemLocation.tab"
                              style="padding: 0 5px 5px 5px"
                            >
                              <div style="min-height: 60vh">
                                <v-card dense elevation="0">
                                  <v-expansion-panels
                                    v-model="panel"
                                    focusable
                                    multiple
                                    class="mt-1"
                                  >
                                    <v-expansion-panel
                                      v-for="(obj, i) in scoreItem[
                                        itemLocation.tab
                                      ]"
                                      :key="i"
                                    >
                                      <v-expansion-panel-header
                                        color="transparent"
                                      >
                                        <!-- <v-checkbox v-if="detailData.status.id == 0" style="margin:0 0 5px 0; padding:0; height: 19px;" @click.stop
                                        ></v-checkbox>  -->
                                        {{ i }}
                                      </v-expansion-panel-header>
                                      <v-expansion-panel-content>
                                        <v-form
                                          ref="auditItemScoreTable"
                                          readonly
                                        >
                                          <v-data-table
                                            v-model="selectedData"
                                            fixed-header
                                            mobile-breakpoint="0"
                                            height="50vh"
                                            item-key="id"
                                            style="cursor: pointer"
                                            elevation="1"
                                            :headers="scoreItemHeaders"
                                            :items="obj"
                                            :loading="loading"
                                            :footer-props="{
                                              showFirstLastPage: true,
                                              showCurrentPage: true,
                                              itemsPerPageOptions: [
                                                1, 3, 5, 10, 15, 100
                                              ]
                                            }"
                                            @click:row="scoreItemRowClick"
                                            :show-select="
                                              (detailData.status.id == 0 ||
                                                detailData.status.id == 2) &&
                                              checkScheduleArea(obj, i)
                                            "
                                          >
                                            <!-- :show-select="
                                              (detailData.status.id == 0 ||
                                                detailData.status.id == 2) &&
                                              isAdminOrAuditor
                                            " -->
                                            <template
                                              v-slot:[`item.no`]="{ index }"
                                            >
                                              <div
                                                style="
                                                  font-size: 14px;
                                                  padding: 0;
                                                  display: flex;
                                                  flex-direction: row;
                                                "
                                              >
                                                {{
                                                  index +
                                                  1 +
                                                  paramAPI.offset *
                                                    paramAPI.limit
                                                }}
                                              </div>
                                            </template>
                                            <template
                                              v-slot:[`item.clause_desc`]="{
                                                item
                                              }"
                                            >
                                              <div
                                                style="
                                                  width: 240px;
                                                  font-size: 12px;
                                                  padding: 0;
                                                  display: flex;
                                                  flex-direction: row;
                                                "
                                              >
                                                {{ item.clause_desc }}
                                              </div>
                                            </template>
                                            <template
                                              v-slot:[`item.clause_no`]="{
                                                item
                                              }"
                                            >
                                              <div
                                                style="
                                                  width: 70px;
                                                  font-size: 12px;
                                                  padding: 0;
                                                  display: flex;
                                                  flex-direction: row;
                                                "
                                              >
                                                {{ item.clause_no }}
                                              </div>
                                            </template>
                                            <template
                                              v-slot:[`item.corrective_evidence`]="{
                                                item
                                              }"
                                            >
                                              <div
                                                @click.stop="
                                                  openEvidenceDialog(
                                                    item.id,
                                                    item.corrective_evidence,
                                                    'Corrective',
                                                    item.status,
                                                    obj
                                                  )
                                                "
                                                style="
                                                  width: 90px;
                                                  font-size: 12px;
                                                  padding: 0;
                                                  display: flex;
                                                  flex-direction: row;
                                                "
                                              >
                                                <v-btn
                                                  v-if="
                                                    item.corrective_evidence !=
                                                      null &&
                                                    item.corrective_evidence
                                                      .length > 0
                                                  "
                                                  x-small
                                                  text
                                                  outlined
                                                  color="primary"
                                                >
                                                  <v-icon x-small
                                                    >mdi-magnify</v-icon
                                                  >
                                                  Lihat
                                                </v-btn>
                                                <v-btn
                                                  v-else
                                                  x-small
                                                  text
                                                  outlined
                                                  color="green"
                                                >
                                                  <v-icon x-small
                                                    >mdi-upload</v-icon
                                                  >Upload
                                                </v-btn>
                                              </div>
                                            </template>
                                            <template
                                              v-slot:[`item.objective_evidence`]="{
                                                item
                                              }"
                                            >
                                              <div
                                                @click.stop="
                                                  openEvidenceDialog(
                                                    item.id,
                                                    item.objective_evidence,
                                                    'Objective',
                                                    item.status,
                                                    obj
                                                  )
                                                "
                                                style="
                                                  width: 90px;
                                                  font-size: 12px;
                                                  padding: 0;
                                                  display: flex;
                                                  flex-direction: row;
                                                "
                                              >
                                                <v-btn
                                                  v-if="
                                                    item.objective_evidence !=
                                                      null &&
                                                    item.objective_evidence
                                                      .length > 0
                                                  "
                                                  x-small
                                                  text
                                                  outlined
                                                  color="primary"
                                                >
                                                  <v-icon x-small
                                                    >mdi-magnify</v-icon
                                                  >
                                                  Lihat
                                                </v-btn>
                                                <v-btn
                                                  v-else
                                                  x-small
                                                  text
                                                  outlined
                                                  color="green"
                                                >
                                                  <v-icon x-small
                                                    >mdi-upload</v-icon
                                                  >Upload
                                                </v-btn>
                                              </div>
                                            </template>

                                            <template
                                              v-slot:[`item.corrective_due_date`]="{
                                                item
                                              }"
                                            >
                                              <div
                                                @click.stop
                                                style="
                                                  width: 110px;
                                                  height: 40px;
                                                  font-size: 12px;
                                                  padding: 0;
                                                  display: flex;
                                                  flex-direction: row;
                                                "
                                              >
                                                <v-text-field
                                                  style="font-size: 12px"
                                                  v-model="
                                                    item.corrective_due_date
                                                  "
                                                  type="date"
                                                  name="date"
                                                  step="1"
                                                  dense
                                                  @change="
                                                    updateCorrectiveDueDate(
                                                      item
                                                    )
                                                  "
                                                  :readonly="
                                                    detailData.status.id != 2 ||
                                                    item.status != 1 ||
                                                    !isAuditee
                                                  "
                                                />
                                              </div>
                                            </template>
                                            <template
                                              v-slot:[`item.corrective_plan_due_date`]="{
                                                item
                                              }"
                                            >
                                              <div
                                                @click.stop
                                                style="
                                                  width: 110px;
                                                  height: 40px;
                                                  font-size: 12px;
                                                  padding: 0;
                                                  display: flex;
                                                  flex-direction: row;
                                                "
                                              >
                                                <v-text-field
                                                  @change="
                                                    updateCorrectivePlanDueDate(
                                                      item
                                                    )
                                                  "
                                                  style="font-size: 12px"
                                                  v-model="
                                                    item.corrective_plan_due_date
                                                  "
                                                  type="date"
                                                  name="date"
                                                  step="1"
                                                  dense
                                                  :readonly="
                                                    detailData.status.id != 2 ||
                                                    item.status != 1 ||
                                                    !isAuditee
                                                  "
                                                />
                                              </div>
                                            </template>
                                            <template
                                              v-slot:[`item.corrective_plan_desc`]="{
                                                item
                                              }"
                                            >
                                              <div
                                                style="
                                                  width: 50px;
                                                  padding: 0;
                                                  display: flex;
                                                  flex-direction: row;
                                                  justify-content: center;
                                                "
                                              >
                                                <v-tooltip
                                                  bottom
                                                  color="primary"
                                                >
                                                  <template
                                                    v-slot:activator="{
                                                      attrs,
                                                      on
                                                    }"
                                                  >
                                                    <div
                                                      v-bind="attrs"
                                                      v-on="on"
                                                      @click.stop="
                                                        openCorrectivePlanDialog(
                                                          item
                                                        )
                                                      "
                                                    >
                                                      <v-icon small color="info"
                                                        >mdi-comment-alert</v-icon
                                                      >
                                                    </div>
                                                  </template>
                                                  <span
                                                    >Klik untuk melihat
                                                    catatan</span
                                                  >
                                                </v-tooltip>
                                              </div>
                                            </template>
                                            <template
                                              v-slot:[`item.verification_note`]="{
                                                item
                                              }"
                                            >
                                              <div
                                                style="
                                                  width: 50px;
                                                  padding: 0;
                                                  display: flex;
                                                  flex-direction: row;
                                                  justify-content: center;
                                                "
                                              >
                                                <v-tooltip
                                                  bottom
                                                  color="primary"
                                                >
                                                  <template
                                                    v-slot:activator="{
                                                      attrs,
                                                      on
                                                    }"
                                                  >
                                                    <div
                                                      v-bind="attrs"
                                                      v-on="on"
                                                      @click.stop="
                                                        openVerificationNoteDialog(
                                                          item
                                                        )
                                                      "
                                                    >
                                                      <v-icon small color="info"
                                                        >mdi-comment-alert</v-icon
                                                      >
                                                    </div>
                                                  </template>
                                                  <span
                                                    >Klik untuk melihat
                                                    catatan</span
                                                  >
                                                </v-tooltip>
                                              </div>
                                            </template>

                                            <template
                                              v-slot:[`item.status`]="{ item }"
                                            >
                                              <div
                                                :style="`
                                      color: ${itemStatusColor(
                                        item.status
                                      )}; font-weight: bold;
                                        font-size: 12px;
                                        padding: 0;
                                        display: flex;
                                        flex-direction: row;`"
                                              >
                                                {{
                                                  itemStatusName(item.status)
                                                }}
                                              </div>
                                            </template>

                                            <!-- Food Safety -->
                                            <template
                                              v-slot:[`item.critical`]="{
                                                item
                                              }"
                                            >
                                              <div
                                                @click.stop
                                                style="
                                                  padding: 0;
                                                  display: flex;
                                                  flex-direction: row;
                                                  justify-content: center;
                                                "
                                              >
                                                <v-radio-group
                                                  v-model="item.score"
                                                  @change="updateScore(item)"
                                                  row
                                                  :readonly="
                                                    detailData.status.id != 2 ||
                                                    item.status != 0 ||
                                                    !checkScheduleArea(obj, i)
                                                  "
                                                >
                                                  <v-tooltip
                                                    bottom
                                                    color="primary"
                                                  >
                                                    <template
                                                      v-slot:activator="{
                                                        attrs,
                                                        on
                                                      }"
                                                    >
                                                      <v-radio
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        :value="{
                                                          id: 6,
                                                          name: 'Critical Deviation',
                                                          value: 0
                                                        }"
                                                        color="success"
                                                      ></v-radio>
                                                    </template>
                                                    <span>
                                                      <!-- Show parameter here -->
                                                    </span>
                                                  </v-tooltip>
                                                </v-radio-group>
                                              </div>
                                            </template>
                                            <template
                                              v-slot:[`item.major`]="{ item }"
                                            >
                                              <div
                                                @click.stop
                                                style="
                                                  padding: 0;
                                                  display: flex;
                                                  flex-direction: row;
                                                  justify-content: center;
                                                "
                                              >
                                                <v-radio-group
                                                  v-model="item.score"
                                                  @change="updateScore(item)"
                                                  column
                                                  :readonly="
                                                    detailData.status.id != 2 ||
                                                    item.status != 0 ||
                                                    !checkScheduleArea(obj, i)
                                                  "
                                                >
                                                  <v-tooltip
                                                    bottom
                                                    color="primary"
                                                  >
                                                    <template
                                                      v-slot:activator="{
                                                        attrs,
                                                        on
                                                      }"
                                                    >
                                                      <v-radio
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        :value="{
                                                          id: 7,
                                                          name: 'Major Deviation',
                                                          value: 0
                                                        }"
                                                        color="success"
                                                      >
                                                      </v-radio>
                                                    </template>
                                                    <span>
                                                      <!-- Show parameter here -->
                                                    </span>
                                                  </v-tooltip>
                                                </v-radio-group>
                                              </div>
                                            </template>
                                            <template
                                              v-slot:[`item.minor`]="{ item }"
                                            >
                                              <div
                                                @click.stop
                                                style="
                                                  padding: 0;
                                                  display: flex;
                                                  flex-direction: row;
                                                  justify-content: center;
                                                "
                                              >
                                                <v-radio-group
                                                  v-model="item.score"
                                                  @change="updateScore(item)"
                                                  column
                                                  :readonly="
                                                    detailData.status.id != 2 ||
                                                    item.status != 0 ||
                                                    !checkScheduleArea(obj, i)
                                                  "
                                                >
                                                  <v-tooltip
                                                    bottom
                                                    color="primary"
                                                  >
                                                    <template
                                                      v-slot:activator="{
                                                        attrs,
                                                        on
                                                      }"
                                                    >
                                                      <v-radio
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        :value="{
                                                          id: 8,
                                                          name: 'Minor Deviation',
                                                          value: 1
                                                        }"
                                                        color="success"
                                                      >
                                                      </v-radio>
                                                    </template>
                                                    <span>
                                                      <!-- Show parameter here -->
                                                    </span>
                                                  </v-tooltip>
                                                </v-radio-group>
                                              </div>
                                            </template>
                                            <template
                                              v-slot:[`item.observation`]="{
                                                item
                                              }"
                                            >
                                              <div
                                                @click.stop
                                                style="
                                                  justify-content: center;
                                                  display: flex;
                                                  flex-direction: row;
                                                  justify-content: center;
                                                "
                                              >
                                                <v-radio-group
                                                  v-model="item.score"
                                                  @change="updateScore(item)"
                                                  column
                                                  :readonly="
                                                    detailData.status.id != 2 ||
                                                    item.status != 0 ||
                                                    !checkScheduleArea(obj, i)
                                                  "
                                                >
                                                  <v-tooltip
                                                    bottom
                                                    color="primary"
                                                  >
                                                    <template
                                                      v-slot:activator="{
                                                        attrs,
                                                        on
                                                      }"
                                                    >
                                                      <v-radio
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        :value="{
                                                          id: 9,
                                                          name: 'Observation',
                                                          value: 3
                                                        }"
                                                        color="success"
                                                      >
                                                      </v-radio>
                                                    </template>
                                                    <span>
                                                      <!-- Show parameter here -->
                                                    </span>
                                                  </v-tooltip>
                                                </v-radio-group>
                                              </div>
                                            </template>
                                            <template
                                              v-slot:[`item.conform`]="{ item }"
                                            >
                                              <div
                                                @click.stop
                                                style="
                                                  padding: 0;
                                                  display: flex;
                                                  flex-direction: row;
                                                  justify-content: center;
                                                "
                                              >
                                                <v-radio-group
                                                  v-model="item.score"
                                                  @change="updateScore(item)"
                                                  column
                                                  :readonly="
                                                    detailData.status.id != 2 ||
                                                    item.status != 0 ||
                                                    !checkScheduleArea(obj, i)
                                                  "
                                                >
                                                  <v-tooltip
                                                    bottom
                                                    color="primary"
                                                  >
                                                    <template
                                                      v-slot:activator="{
                                                        attrs,
                                                        on
                                                      }"
                                                    >
                                                      <v-radio
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        :value="{
                                                          id: 10,
                                                          name: 'Conform',
                                                          value: 4
                                                        }"
                                                        color="success"
                                                      >
                                                      </v-radio>
                                                    </template>
                                                    <span>
                                                      <!-- Show parameter here -->
                                                    </span>
                                                  </v-tooltip>
                                                </v-radio-group>
                                              </div>
                                            </template>

                                            <!-- 5R -->
                                            <template
                                              v-slot:[`item.very_bad`]="{
                                                item
                                              }"
                                            >
                                              <div
                                                @click.stop
                                                style="
                                                  padding: 0;
                                                  display: flex;
                                                  flex-direction: row;
                                                  justify-content: center;
                                                "
                                              >
                                                <v-radio-group
                                                  v-model="item.score"
                                                  @change="updateScore(item)"
                                                  column
                                                  :readonly="
                                                    detailData.status.id != 2 ||
                                                    item.status != 0 ||
                                                    !checkScheduleArea(obj, i)
                                                  "
                                                >
                                                  <v-tooltip
                                                    bottom
                                                    color="primary"
                                                  >
                                                    <template
                                                      v-slot:activator="{
                                                        attrs,
                                                        on
                                                      }"
                                                    >
                                                      <v-radio
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        :value="{
                                                          id: 1,
                                                          name: 'Sangat Buruk',
                                                          value: 1
                                                        }"
                                                        color="success"
                                                      >
                                                      </v-radio>
                                                    </template>
                                                    <span>
                                                      <!-- Show parameter here -->
                                                    </span>
                                                  </v-tooltip>
                                                </v-radio-group>
                                              </div>
                                            </template>
                                            <template
                                              v-slot:[`item.bad`]="{ item }"
                                            >
                                              <div
                                                @click.stop
                                                style="
                                                  padding: 0;
                                                  display: flex;
                                                  flex-direction: row;
                                                  justify-content: center;
                                                "
                                              >
                                                <v-radio-group
                                                  v-model="item.score"
                                                  @change="updateScore(item)"
                                                  column
                                                  :readonly="
                                                    detailData.status.id != 2 ||
                                                    item.status != 0 ||
                                                    !checkScheduleArea(obj, i)
                                                  "
                                                >
                                                  <v-tooltip
                                                    bottom
                                                    color="primary"
                                                  >
                                                    <template
                                                      v-slot:activator="{
                                                        attrs,
                                                        on
                                                      }"
                                                    >
                                                      <v-radio
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        :value="{
                                                          id: 2,
                                                          name: 'Buruk',
                                                          value: 2
                                                        }"
                                                        color="success"
                                                      >
                                                      </v-radio>
                                                    </template>
                                                    <span>
                                                      <!-- Show parameter here -->
                                                    </span>
                                                  </v-tooltip></v-radio-group
                                                >
                                              </div>
                                            </template>
                                            <template
                                              v-slot:[`item.enough`]="{ item }"
                                            >
                                              <div
                                                @click.stop
                                                style="
                                                  padding: 0;
                                                  display: flex;
                                                  flex-direction: row;
                                                  justify-content: center;
                                                "
                                              >
                                                <v-radio-group
                                                  v-model="item.score"
                                                  @change="updateScore(item)"
                                                  column
                                                  :readonly="
                                                    detailData.status.id != 2 ||
                                                    item.status != 0 ||
                                                    !checkScheduleArea(obj, i)
                                                  "
                                                >
                                                  <v-tooltip
                                                    bottom
                                                    color="primary"
                                                  >
                                                    <template
                                                      v-slot:activator="{
                                                        attrs,
                                                        on
                                                      }"
                                                    >
                                                      <v-radio
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        :value="{
                                                          id: 3,
                                                          name: 'Cukup',
                                                          value: 3
                                                        }"
                                                        color="success"
                                                      >
                                                      </v-radio>
                                                    </template>
                                                    <span>
                                                      <!-- Show parameter here -->
                                                    </span>
                                                  </v-tooltip>
                                                </v-radio-group>
                                              </div>
                                            </template>
                                            <template
                                              v-slot:[`item.good`]="{ item }"
                                            >
                                              <div
                                                @click.stop
                                                style="
                                                  padding: 0;
                                                  display: flex;
                                                  flex-direction: row;
                                                  justify-content: center;
                                                "
                                              >
                                                <v-radio-group
                                                  v-model="item.score"
                                                  @change="updateScore(item)"
                                                  column
                                                  :readonly="
                                                    detailData.status.id != 2 ||
                                                    item.status != 0 ||
                                                    !checkScheduleArea(obj, i)
                                                  "
                                                >
                                                  <v-tooltip
                                                    bottom
                                                    color="primary"
                                                  >
                                                    <template
                                                      v-slot:activator="{
                                                        attrs,
                                                        on
                                                      }"
                                                    >
                                                      <v-radio
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        :value="{
                                                          id: 4,
                                                          name: 'Baik',
                                                          value: 4
                                                        }"
                                                        color="success"
                                                      >
                                                      </v-radio>
                                                    </template>
                                                    <span>
                                                      <!-- Show parameter here -->
                                                    </span>
                                                  </v-tooltip>
                                                </v-radio-group>
                                              </div>
                                            </template>
                                            <template
                                              v-slot:[`item.very_good`]="{
                                                item
                                              }"
                                            >
                                              <div
                                                @click.stop
                                                style="
                                                  padding: 0;
                                                  display: flex;
                                                  flex-direction: row;
                                                  justify-content: flex-end;
                                                "
                                              >
                                                <v-radio-group
                                                  v-model="item.score"
                                                  @change="updateScore(item)"
                                                  column
                                                  :readonly="
                                                    detailData.status.id != 2 ||
                                                    item.status != 0 ||
                                                    !checkScheduleArea(obj, i)
                                                  "
                                                >
                                                  <v-tooltip
                                                    bottom
                                                    color="primary"
                                                  >
                                                    <template
                                                      v-slot:activator="{
                                                        attrs,
                                                        on
                                                      }"
                                                    >
                                                      <v-radio
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        :value="{
                                                          id: 5,
                                                          name: 'Sangat Baik',
                                                          value: 5
                                                        }"
                                                        color="success"
                                                      >
                                                      </v-radio>
                                                    </template>
                                                    <span>
                                                      <!-- Show parameter here -->
                                                    </span>
                                                  </v-tooltip>
                                                </v-radio-group>
                                              </div>
                                            </template>
                                          </v-data-table>
                                        </v-form>
                                      </v-expansion-panel-content>
                                    </v-expansion-panel>
                                  </v-expansion-panels>
                                </v-card>
                              </div>
                            </v-tab-item>
                          </v-tabs-items>
                        </v-tabs>
                      </v-card>
                      <v-card
                        v-else
                        class="mt-5"
                        style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          font-size: 14px;
                          height: 60vh;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.6);
                          background: rgba(255, 255, 255);
                        "
                      >
                        DATA NOT FOUND
                      </v-card>
                    </div>
                    <div
                      v-if="
                        detailData.audit_type.id == 2 && item.tab == 'Hasil'
                      "
                    >
                      <v-row
                        v-if="
                          detailData.audit_score_result != null &&
                          detailData.audit_score_result.length > 0
                        "
                        class="mt-1"
                      >
                        <v-col cols="12">
                          <v-card elevation="1" class="result-5r">
                            <table border="1" cellpadding="8" cellspacing="0">
                              <thead>
                                <tr>
                                  <th colspan="6">5R ALL AREA</th>
                                  <th rowspan="2">MAINTENANCE</th>
                                  <th rowspan="2">INTERVIEW</th>
                                  <th rowspan="2">TOTAL</th>
                                </tr>
                                <tr>
                                  <th>AUDITOR</th>
                                  <th>RINGKAS</th>
                                  <th>RAPI</th>
                                  <th>RESIK</th>
                                  <th>RAWAT</th>
                                  <th>RAJIN</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(
                                    item, index
                                  ) in detailData.audit_score_result"
                                  :key="index"
                                >
                                  <td>
                                    <strong>{{ item.employee_name }}</strong>
                                  </td>
                                  <td>{{ getRingkasValue(item) }}</td>
                                  <td>{{ getRapihValue(item) }}</td>
                                  <td>{{ getResikValue(item) }}</td>
                                  <td>{{ getRawatValue(item) }}</td>
                                  <td>{{ getRajinValue(item) }}</td>
                                  <td>{{ getMaintenanceValue(item) }}</td>
                                  <td>{{ getInterviewValue(item) }}</td>
                                  <td>{{ item.total }}</td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <strong>GRAND TOTAL</strong>
                                  </td>
                                  <td>
                                    <strong>{{
                                      detailData.audit_score_total
                                    }}</strong>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">NILAI</td>
                                  <td>
                                    <strong>{{
                                      detailData.audit_score_grade != null
                                        ? detailData.audit_score_grade.name
                                        : '-'
                                    }}</strong>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </v-card>
                        </v-col>
                      </v-row>
                      <!-- <v-row class="mt-2">
                        <v-col cols="2">
                          <v-card elevation="1" outlined>
                            <v-list-item three-line>
                              <v-list-item-content class="text-center">
                                <div class="text-overline font-bold mb-2">
                                  Total
                                </div>
                                <v-list-item-title class="text-h4 font-bold">
                                  180.2
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-card>
                        </v-col>

                        <v-col cols="2">
                          <v-card
                            elevation="1"
                            outlined
                            style="margin-left: 15px"
                          >
                            <v-list-item three-line>
                              <v-list-item-content class="text-center">
                                <div class="text-overline font-bold mb-2">
                                  Nilai
                                </div>
                                <v-list-item-title class="text-h4 font-bold">
                                  A-
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-card>
                        </v-col>
                      </v-row> -->
                    </div>
                    <div v-if="item.tab == 'Anggota'" style="padding-top: 10px">
                      <div class="position-relative z-0">
                        <v-btn
                          v-if="
                            !isEdit &&
                            detailData.status.id == 0 &&
                            getUserProfile.level.find(
                              ({ id }) =>
                                id == appLevel.adminAudit ||
                                id == appLevel.administrator
                            ) !== undefined
                          "
                          color="blue darken-1"
                          type="button"
                          small
                          outlined
                          class="white--text"
                          style="position: relative; top: 0px; z-index: 2"
                          @click="addMember"
                        >
                          + Tambah
                        </v-btn>
                      </div>
                      <v-data-table
                        v-model="selectedDataMember"
                        fixed-header
                        mobile-breakpoint="0"
                        height="50vh"
                        item-key="id"
                        style="cursor: pointer"
                        elevation="1"
                        :headers="memberHeaders"
                        :items="detailData.audit_member"
                        :loading="loading"
                        :footer-props="{
                          showFirstLastPage: true,
                          showCurrentPage: true,
                          itemsPerPageOptions: [1, 3, 5, 10, 15, 100]
                        }"
                        @click:row="memberRowClick"
                      >
                        <template v-slot:[`item.employee_name`]="{ item }">
                          <div
                            style="
                              width: 210px;
                              font-size: 12px;
                              padding: 0;
                              display: flex;
                              flex-direction: row;
                            "
                          >
                            {{ item.employee_name }}
                          </div>
                        </template>
                        <template v-slot:[`item.member_type`]="{ item }">
                          <div
                            style="
                              width: 90px;
                              font-size: 12px;
                              padding: 0;
                              display: flex;
                              flex-direction: row;
                            "
                          >
                            {{
                              dropdown.memberType.find(
                                ({ id }) => id == item.member_type
                              ).name
                            }}
                          </div>
                        </template>
                        <template v-slot:[`item.area_ids`]="{ item }">
                          <div
                            style="
                              width: 720px;
                              font-size: 12px;
                              padding: 0;
                              display: flex;
                              flex-direction: row;
                              overflow: auto;
                            "
                          >
                            <v-chip
                              v-for="(obj, idx) in item.area_ids"
                              :key="idx"
                              label
                              outlined
                              small
                              style="
                                min-width: 120px;
                                position: relative;
                                margin-right: 5px;
                                padding: 0 3px;
                                cursor: pointer;
                                border: 1px solid rgba(0, 0, 0, 0.5);
                              "
                            >
                              {{ getAreaName(obj) }}
                            </v-chip>
                          </div>
                        </template>
                        <template v-slot:[`item.scope_ids`]="{ item }">
                          <div
                            style="
                              min-width: 420px;
                              max-width: 620px;
                              font-size: 12px;
                              padding: 0;
                              display: flex;
                              flex-direction: row;
                              overflow: auto;
                            "
                          >
                            <v-chip
                              v-for="(obj, idx) in item.scope_ids"
                              :key="idx"
                              label
                              outlined
                              small
                              style="
                                min-width: 120px;
                                position: relative;
                                margin-right: 5px;
                                padding: 0 3px;
                                cursor: pointer;
                                border: 1px solid rgba(0, 0, 0, 0.5);
                              "
                            >
                              {{ getScopeName(obj) }}
                            </v-chip>
                          </div>
                        </template>
                        <template v-slot:[`item.action`]="{ item }">
                          <div
                            style="
                              font-size: 12px;
                              padding: 0;
                              display: flex;
                              flex-direction: row;
                            "
                          >
                            <v-btn
                              icon
                              x-small
                              @click.stop="memberRowClick(item)"
                            >
                              <v-icon color="primary">mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              x-small
                              @click.stop="deleteMember(item)"
                              style="margin-right: 5px"
                            >
                              <v-icon color="red">mdi-delete</v-icon>
                            </v-btn>
                          </div>
                        </template>
                      </v-data-table>
                    </div>
                    <div v-if="item.tab == 'Approval'">
                      <div v-if="detailData != null" style="margin-top: 5px">
                        <v-row
                          no-gutters
                          style="padding: 0"
                          v-if="detailData.approval_matrix !== null"
                        >
                          <v-col md="12" style="padding: 0">
                            <v-data-table
                              mobile-breakpoint="0"
                              :headers="approvalHeaders"
                              :items="detailData.approval_matrix"
                              :items-per-page="10"
                              class="elevation-1 mx-auto"
                              hide-default-footer
                            >
                              <template v-slot:[`item.document_no`]="{ item }">
                                <div style="width: 140px; font-size: 12px">
                                  {{ item.document_no }}
                                </div>
                              </template>
                              <template v-slot:[`item.table_name`]="{ item }">
                                <div style="width: 140px; font-size: 12px">
                                  {{ item.table_name }}
                                </div>
                              </template>
                              <template
                                v-slot:[`item.approver_user`]="{ item }"
                              >
                                <div style="cursor: pointer" v-if="item">
                                  <v-chip
                                    label
                                    outlined
                                    small
                                    style="
                                      margin-right: 5px;
                                      padding: 0 3px;
                                      cursor: pointer;
                                      border: 1px solid rgba(0, 0, 0, 0.5);
                                    "
                                    v-for="(item, index) in item.approver_user"
                                    :key="index"
                                  >
                                    {{
                                      item.user !== null ? item.user.name : '-'
                                    }}
                                  </v-chip>
                                </div>
                              </template>
                              <template v-slot:[`item.approved`]="{ item }">
                                <div
                                  v-for="(items, index) in item.approver_user"
                                  :key="index"
                                  style="width: 140px"
                                >
                                  <v-chip
                                    v-if="items.status === 1"
                                    label
                                    outlined
                                    small
                                    style="
                                      position: relative;
                                      margin-right: 5px;
                                      padding: 0 3px;
                                      cursor: pointer;
                                      border: 1px solid rgba(0, 0, 0, 0.5);
                                    "
                                  >
                                    {{
                                      item.user !== null ? items.user.name : '-'
                                    }}
                                    <v-tooltip bottom color="primary">
                                      <template
                                        v-slot:activator="{ attrs, on }"
                                      >
                                        <div
                                          v-if="items.note"
                                          v-bind="attrs"
                                          v-on="on"
                                          @click="openCommentDialog(items)"
                                          style="
                                            position: absolute;
                                            top: 0;
                                            right: 0;
                                            width: 20px;
                                            bottom: 0;
                                            background: white;
                                          "
                                        >
                                          <v-icon small color="info"
                                            >mdi-comment-alert</v-icon
                                          >
                                        </div>
                                      </template>
                                      <span>Klik untuk melihat catatan</span>
                                    </v-tooltip>
                                  </v-chip>
                                </div>
                              </template>
                              <template v-slot:[`item.rejected`]="{ item }">
                                <div
                                  v-for="(items, index) in item.approver_user"
                                  :key="index"
                                  style="width: 140px"
                                >
                                  <v-chip
                                    v-if="items.status === -1"
                                    label
                                    outlined
                                    small
                                    style="
                                      margin-right: 5px;
                                      padding: 0 3px;
                                      cursor: pointer;
                                    "
                                  >
                                    {{
                                      item.user !== null ? items.user.name : '-'
                                    }}
                                    <v-tooltip bottom>
                                      <template
                                        v-slot:activator="{ attrs, on }"
                                      >
                                        <div
                                          v-if="items.note"
                                          v-bind="attrs"
                                          v-on="on"
                                          @click="openCommentDialog(items)"
                                          style="
                                            position: absolute;
                                            top: 0;
                                            right: 0;
                                            width: 20px;
                                            bottom: 0;
                                            background: white;
                                          "
                                        >
                                          <v-icon small color="info"
                                            >mdi-comment-alert</v-icon
                                          >
                                        </div>
                                      </template>
                                      <span>Klik untuk melihat catatan</span>
                                    </v-tooltip>
                                  </v-chip>
                                </div>
                              </template>
                              <template v-slot:[`item.created_at`]="{ item }">
                                <div style="width: 140px; font-size: 12px">
                                  {{ item.created_at }}
                                </div>
                              </template>
                              <template v-slot:[`item.updated_at`]="{ item }">
                                <div
                                  v-for="(items, index) in item.approver_user"
                                  :key="index"
                                  style="width: 140px; font-size: 12px"
                                >
                                  <span v-if="items.status === 1">
                                    {{
                                      items.updated_at !== null
                                        ? items.updated_at
                                        : '-'
                                    }}
                                  </span>
                                  <br v-if="index > 0" />
                                </div>
                              </template>
                            </v-data-table>
                          </v-col>
                        </v-row>
                        <div
                          v-if="
                            getUserProfile.level.find(
                              ({ id }) =>
                                id == appLevel.adminAudit ||
                                id == appLevel.administrator
                            ) !== undefined
                          "
                        >
                          <div
                            style="text-align: left; padding-left: 5px"
                            v-if="detailData.status.id == 1"
                          >
                            <v-btn
                              color="grey"
                              tile
                              dark
                              small
                              dense
                              style="
                                font-size: 10px;
                                width: 100px;
                                margin-top: 10px;
                              "
                              :loading="loading"
                              @click="fetchMatrix"
                            >
                              <span>Fetch Matrix</span>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="item.tab == 'Temuan Lain'"
                      style="padding-top: 10px"
                    >
                      <DiscoverySection
                        ref="discoverySectionRef"
                        @getDiscoveryItems="getDiscoveryItems"
                        :detailData="detailData"
                        :discoveryData="discoveryData"
                        :getUserProfile="getUserProfile"
                        :appLevel="appLevel"
                        :loading="loading"
                        :dropdown="dropdown"
                        :evidenceHeaders="evidenceHeaders"
                      />
                    </div>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
            <div
              v-else
              class="d-flex justify-center align-center"
              style="height: 150px"
            >
              <v-progress-circular
                :size="80"
                :width="5"
                color="blue"
                indeterminate
                >Loading...</v-progress-circular
              >
            </div>
          </v-card-text>
        </v-card>

        <!--DIALOG MODAL  -->

        <v-card
          v-else
          class="mx-auto"
          width="100%"
          style="
            z-index: 3;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            position: fixed;
            top: 0;
            height: 100%;
            left: 0;
            right: 0;
            background: rgba(255, 255, 255);
          "
        >
          YOU CANNOT ACCESS THIS PAGE
        </v-card>
        <!-- DIALOG -->

        <!-- <v-dialog v-model="formClauseDialog" persistent max-width="800px">
      <v-card v-if="form != null">
        <v-card-title>
          <span class="text-h5">Add/Edit Klausul</span>
        </v-card-title>
        <v-form ref="entryForm2" @submit.prevent="saveClause">
          <v-card-text>
            <v-container>
              <v-row no-gutters>
                <v-col cols="12" md="8" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Perusahaan
                  </p>
                  <v-text-field
                    :value="detailData.company_name"
                    dense
                    outlined
                    style="height: 60px"
                    disabled
                  />
                </v-col>
                <v-col cols="12" md="4" class="d-flex flex-column pl-5">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Tipe Audit
                  </p>
                  <v-text-field
                    :value="detailData.audit_type.name"
                    dense
                    outlined
                    style="height: 60px"
                    disabled
                  />
                </v-col>
                <v-col cols="12" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Klausul
                  </p>
                  <v-autocomplete
                    v-if="form.act == 'add'"
                    v-model="form.clause"
                    clearable
                    deletable-chips
                    small-chips
                    outlined
                    item-text="description"
                    item-id="id"
                    return-object
                    label="Cari klausul"
                    :items="clauseList"
                    :search-input.sync="search"
                    :rules="rules.clauseRules"
                    @change="clauseWatcher"
                  ></v-autocomplete>
                  <v-textarea
                    v-if="form.act == 'update'"
                    :value="form.clause.description"
                    dense
                    outlined
                    auto-grow
                    rows="2"
                    disabled
                  />
                </v-col>
                <v-col
                  v-if="form.clause != null"
                  cols="12"
                  class="d-flex flex-column"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Kategori Klausul
                  </p>
                  <v-text-field
                    dense
                    outlined
                    style="height: 60px"
                    :value="
                      form.clause.clause_category != null
                        ? form.clause.clause_category.name
                        : null
                    "
                    disabled
                  />
                </v-col>
                <v-col
                  v-if="form.clause != null"
                  cols="12"
                  md="4"
                  class="d-flex flex-column"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    No Klausul
                  </p>
                  <v-text-field
                    :value="form.clause.clause_no"
                    dense
                    outlined
                    style="height: 60px"
                    disabled
                  />
                </v-col>
                <v-col
                  v-if="form.clause != null"
                  cols="12"
                  md="8"
                  class="d-flex flex-column pl-5"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Referensi
                  </p>
                  <v-text-field
                    v-model="form.clause.reference"
                    dense
                    outlined
                    style="height: 60px"
                    disabled
                  />
                </v-col>
                <v-col
                  v-if="detailData.audit_type_id == 2"
                  cols="6"
                  class="d-flex flex-column"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Area
                  </p>
                  <v-autocomplete
                    v-model="form.area_id"
                    :items="dropdown.area"
                    item-text="name"
                    item-value="id"
                    return-id
                    dense
                    outlined
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col
                  v-if="detailData.audit_type_id == 1"
                  cols="6"
                  class="d-flex flex-column"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Scope
                  </p>
                  <v-autocomplete
                    v-model="form.scope_id"
                    :items="dropdown.scope"
                    item-text="name"
                    item-value="id"
                    return-id
                    dense
                    outlined
                    clearable
                    small-chips
                    deletable-chips
                    multiple
                    cache-items
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeClauseDialog">
              Close
            </v-btn>
            <v-btn color="blue darken-1" text type="submit"> Save </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog> -->
        <v-dialog
          v-if="correctivePlanDesc != null"
          v-model="correctivePlanDialog"
          width="500"
          persistent
        >
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Rencana Perbaikan
            </v-card-title>

            <v-card-text class="d-flex justify-center align-center">
              <v-col md="12" style="padding: 0; position: relative; top: 20px">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <v-textarea
                      v-model="correctivePlanDesc.corrective_plan_desc"
                      :auto-grow="true"
                      rows="3"
                      outlined
                      clear-icon="mdi-close-circle"
                      :readonly="detailData.status.id != 2"
                    ></v-textarea>
                  </v-col>
                </div>
              </v-col>
            </v-card-text>

            <v-divider></v-divider>

            <v-btn
              style="position: absolute; top: 10px; right: 10px"
              fab
              icon
              x-small
              outlined
              @click="closeCorrectivePlanDialog"
            >
              <v-icon size="30" color="red">mdi-close</v-icon>
            </v-btn>
            <v-card-actions
              v-if="
                detailData.status.id == 2 &&
                correctivePlanDesc.status == 1 &&
                isAuditee
              "
            >
              <v-btn
                color="primary"
                text
                outlined
                @click="updateCorrectivePlanDesc"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-if="verificationNote != null"
          v-model="verificationNoteDialog"
          width="500"
          persistent
        >
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Catatan Verifikasi
            </v-card-title>

            <v-card-text class="d-flex justify-center align-center">
              <v-col md="12" style="padding: 0; position: relative; top: 20px">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <v-textarea
                      v-model="verificationNote.verification_note"
                      :auto-grow="true"
                      rows="3"
                      outlined
                      clear-icon="mdi-close-circle"
                      :readonly="detailData.status.id != 2"
                    ></v-textarea>
                  </v-col>
                </div>
              </v-col>
            </v-card-text>

            <v-divider></v-divider>

            <v-btn
              style="position: absolute; top: 10px; right: 10px"
              fab
              icon
              x-small
              outlined
              @click="closeVerificationNoteDialog"
            >
              <v-icon size="30" color="red">mdi-close</v-icon>
            </v-btn>
            <!-- <v-card-actions v-if="detailData.status.id == 2">
              <v-btn
                color="primary"
                text
                outlined
                @click="updateVerificationNote"
              >
                Save
              </v-btn>
            </v-card-actions> -->
          </v-card>
        </v-dialog>

        <v-dialog
          v-if="detailData !== null"
          v-model="evidenceDialog"
          width="500"
          persistent
        >
          <v-card style="position: relative">
            <v-card-title class="text-h5 grey lighten-2">
              {{ evidenceTitleModal }} Evidence File
            </v-card-title>
            <v-card-text class="d-flex justify-center align-center">
              <v-col md="12" style="padding: 0; position: relative; top: 20px">
                <v-data-table
                  v-if="evidenceFile != null"
                  mobile-breakpoint="0"
                  fixed-header
                  height="300"
                  style="cursor: pointer"
                  :headers="evidenceHeaders"
                  :items="evidenceFile"
                  @click:row="readyToDownload"
                >
                  <template v-slot:[`item.subject`]="{ item }">
                    <div
                      style="
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{
                        item.subject !== null
                          ? item.subject !== ''
                            ? item.subject
                            : '-'
                          : '-'
                      }}
                    </div>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <div
                      style="
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      <v-btn
                        v-if="isCanAccessItemUpload"
                        icon
                        x-small
                        @click.stop="
                          unlinkDokumen(
                            item.file.slice(item.file.lastIndexOf('/') + 1)
                          )
                        "
                        style="margin-right: 5px"
                      >
                        <v-icon color="red">mdi-delete</v-icon>
                      </v-btn>
                      <v-btn icon x-small @click.stop="readyToDownload(item)">
                        <v-icon color="green">mdi-download</v-icon>
                      </v-btn>
                    </div>
                  </template>
                </v-data-table>

                <v-btn
                  v-if="isCanAccessItemUpload"
                  elevation="0"
                  style="margin-right: auto; width: 100%"
                  :loading="loading"
                  color="primary"
                  @click="openUploadModal('upload')"
                >
                  <v-icon small style="margin-right: 5px">mdi-upload</v-icon>
                  <span :style="`font-weight: bold; color:white;`"
                    >Tambah File</span
                  >
                </v-btn>
              </v-col>
            </v-card-text>
            <v-divider></v-divider>

            <v-card-actions>
              <v-btn
                color="error"
                text
                outlined
                @click="closeEvidenceDialog"
                :loading="loading"
              >
                Close
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                v-if="isCanAccessItemUpload"
                color="error"
                text
                outlined
                :loading="loading"
                @click="deleteAllFile"
              >
                Delete all File
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="uploadDialog" width="500" persistent>
          <v-form
            :disabled="loading"
            lazy-validation
            ref="entryFormUpload"
            @submit.prevent="submitUploadDoc"
            style="position: relative"
          >
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                UPLOAD
              </v-card-title>

              <v-card-text class="d-flex justify-center align-center">
                <v-col
                  md="12"
                  style="padding: 0; position: relative; top: 20px"
                >
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Subject
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <div>
                        <v-text-field
                          outlined
                          v-model="file_subject"
                          dense
                          :rules="rules.subjectRules"
                        ></v-text-field>
                      </div>
                      <div
                        style="
                          padding: 10px;
                          border: 2px dashed grey;
                          height: 70px;
                        "
                      >
                        <v-file-input
                          ref="uploadDoc"
                          placeholder="Pilih File"
                          dense
                          append-icon="mdi-paperclip"
                          prepend-icon=""
                          @change="uploadFile"
                          :rules="rules.docRules"
                        ></v-file-input>
                      </div>
                    </v-col>
                  </div>
                </v-col>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-btn
                  id="closeFileUpload"
                  color="error"
                  text
                  outlined
                  type="reset"
                  @click="openUploadModal('close')"
                  :loading="loading"
                >
                  close
                </v-btn>
                <v-spacer />
                <v-btn
                  color="primary"
                  text
                  outlined
                  type="submit"
                  :loading="loading"
                  :disabled="fileName === '' || file_subject === ''"
                >
                  simpan file
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <v-dialog v-model="commentDialog" width="500" persistent>
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Catatan Approval
            </v-card-title>

            <v-card-text class="d-flex justify-center align-center">
              <v-col md="12" style="padding: 0; position: relative; top: 20px">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <p
                      style="margin: 0; font-weight: bold"
                      v-if="commentNote != null"
                    >
                      {{ commentNote.note }}
                    </p>
                  </v-col>
                </div>
              </v-col>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn color="error" text outlined @click="closeCommentDialog">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="formMemberDialog" width="500" persistent>
          <v-form
            v-if="formMember != null"
            :disabled="loading"
            lazy-validation
            ref="entryFormMember"
            @submit.prevent="saveFormMember"
            style="position: relative"
          >
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                Tambah Anggota
              </v-card-title>

              <v-card-text class="d-flex justify-center align-center">
                <v-row no-gutters class="pb-10">
                  <v-col
                    cols="12"
                    style="padding: 0; position: relative; top: 20px"
                  >
                    <v-row no-gutters style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Karyawan
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <div style="height: 45px">
                          <v-autocomplete
                            v-model="formMember.employee"
                            :items="dropdown.employee"
                            :search-input.sync="searchEmployee"
                            :rules="rules.employee"
                            item-text="name"
                            item-value="id"
                            return-object
                            dense
                            outlined
                            clearable
                            style="margin: 0; height: 55px"
                          >
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-avatar>
                                  <img :src="`${data.item.photo}`" />
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ data.item.name }}
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    {{ data.item.company_name }}-{{
                                      data.item.nik
                                    }}
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-autocomplete>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    style="padding: 0; position: relative; top: 20px"
                  >
                    <v-row no-gutters style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <div style="height: 45px">
                          <v-radio-group
                            v-model="formMember.member_type"
                            row
                            :rules="rules.memberTypeRules"
                          >
                            <v-radio
                              :value="2"
                              color="primary"
                              label="Leader"
                            ></v-radio>
                            <v-radio
                              :value="1"
                              color="primary"
                              label="Member"
                            ></v-radio>
                          </v-radio-group>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col
                    v-if="detailData.audit_type.id == 2"
                    cols="12"
                    style="padding: 0; position: relative; top: 20px"
                  >
                    <v-row no-gutters style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Area
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <div style="height: 45px">
                          <v-autocomplete
                            v-model="formMember.area_ids"
                            :items="dropdown.area"
                            :rules="rules.memberAreaRules"
                            item-text="name"
                            item-value="id"
                            return-id
                            outlined
                            hide-details
                            hide-no-data
                            clearable
                            small-chips
                            deletable-chips
                            multiple
                            cache-items
                          >
                          </v-autocomplete>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col
                    v-if="detailData.audit_type.id == 1"
                    cols="12"
                    style="padding: 0; position: relative; top: 20px"
                  >
                    <v-row no-gutters style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Scope
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <div style="height: 45px">
                          <v-autocomplete
                            v-model="formMember.scope_ids"
                            :items="dropdown.scope"
                            :rules="rules.memberScopeRules"
                            item-text="name"
                            item-value="id"
                            return-id
                            outlined
                            hide-details
                            hide-no-data
                            clearable
                            small-chips
                            deletable-chips
                            multiple
                            cache-items
                          >
                          </v-autocomplete>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-btn
                  @click="closeFormMember"
                  color="error"
                  text
                  outlined
                  type="button"
                  :loading="loading"
                >
                  Batal
                </v-btn>
                <v-spacer />
                <v-btn
                  color="primary"
                  text
                  outlined
                  type="submit"
                  :loading="loading"
                >
                  simpan
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </div>
      <v-card
        v-else
        flat
        height="90vh"
        style="display: flex; justify-content: center; align-items: center"
      >
        <v-toolbar-title class="overline">
          You Can't Access This Page</v-toolbar-title
        >
      </v-card>
    </div>
    <v-card
      v-else
      flat
      height="90vh"
      style="display: flex; justify-content: center; align-items: center"
    >
      <v-toolbar-title class="overline">
        You Can't Access This Page</v-toolbar-title
      >
    </v-card>
  </div>
  <div v-else>
    <v-card
      class="mx-auto"
      width="100%"
      style="
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        position: fixed;
        top: 0;
        height: 100%;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255);
      "
    >
      <v-progress-circular :size="170" :width="10" color="blue" indeterminate
        >Loading...</v-progress-circular
      >
    </v-card>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import buildType from '../../../services/buildType'
import moment from 'moment'
const env = process.env.VUE_APP_BUILD_TYPE
export default {
  name: 'masterauditType',
  components: {
    DiscoverySection: () => import('./detail/DiscoverySection.vue')
    // FormAuditSection: () => import('./detail/FormAuditSection.vue'),
    // MemberSection: () => import('./detail/MemberSection.vue'),
    // ApprovalSection: () => import('./detail/ApprovalSection.vue'),
    // ResultSection: () => import('./detail/ResultSection.vue')
  },
  data: () => ({
    config: require('../../../services/config.json')[env],
    build: process.env.VUE_APP_BUILD_TYPE,
    oAuthApi: buildType.apiURL('oauth'),
    dssApi: buildType.apiURL('dss'),
    eSanqua: buildType.apiURL('esanqua'),
    uploadApi: buildType.apiURL('upload2'),
    hrsApi: buildType.apiURL('hrs'),
    editDialog: false,
    formClauseDialog: false,
    isAllowApprove: false,
    isAdminOrAuditor: false,
    isAuditee: false,
    isCanAccessItemUpload: false,
    permission: null,
    appLevel: null,
    userLevel: null,
    paramAPI: {
      page: 1,
      keyword: '',
      offset: 0,
      limit: 10,
      itemsPerPage: 10,
      sortBy: 'date',
      sortType: 'desc',
      company_id: null,
      audit_type_id: null,
      area: null,
      scope: null
      // department_id: null
    },
    detailData: null,
    discoveryData: null,
    form: null,
    formMember: null,
    isEdit: false,
    loading: false,
    isDisableCompanyDropdown: false,
    skeleton_loading: true,
    isLoadingPage: true,
    clauseList: [],
    search: null,
    select: null,
    searchEmployee: null,
    selectEmployee: null,
    options: {},
    // result: [],
    rules: {
      nameRules: [],
      companyRules: [],
      auditTypeRules: [],
      clauseRules: [],
      docRules: [],
      subjectRules: [],
      employeeRules: [],
      memberTypeRules: [],
      memberScopeRules: [],
      memberAreaRules: []
    },
    dropdown: {
      company: [],
      auditType: [],
      department: [],
      area: [],
      scope: [],
      employee: [],
      memberType: [
        {
          id: 1,
          name: 'Member'
        },
        {
          id: 2,
          name: 'Leader'
        }
      ],
      template: []
    },
    panel: [],

    tab: null,
    scoreItem: null,

    locationTab: null,
    locationTabItems: [],
    correctivePlanDialog: false,
    correctivePlanDesc: null,
    verificationNoteDialog: false,
    verificationNote: null,
    evidenceDialog: false,
    evidenceFile: null,
    evidenceTitleModal: '',
    fileName: '',
    uploadDialog: false,
    file_subject: null,
    auditItemId: null,
    auditItemStatus: null,

    actionValue: 0,
    selectedData: [],
    itemsAction: [],

    commentDialog: false,
    commentNote: null,
    selectedDataMember: [],

    formMemberDialog: false
  }),

  async mounted() {
    // this.paramAPI.company_id = Number(
    //   this.getUserProfile.employee.company.plant_id
    // )
    // this.paramAPI.department_id = this.getUserProfile.employee.department_id

    this.appLevel = this.config.application.dss.userLevel
    this.appLevel.administrator =
      this.config.application.all.userLevel.administrator
    this.getDataMenu()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  computed: {
    // , 'getDropdownPlant', 'getShiftSettingPageQuery'
    ...mapGetters(['getUserProfile']),
    tabItems() {
      const arr = [
        { tab: 'Form Audit', content: '' },
        { tab: 'Anggota', content: '' },
        { tab: 'Approval', content: '' },
        { tab: 'Temuan Lain', content: '' }
      ]
      if (this.detailData.audit_type.id == 2) {
        arr.push({ tab: 'Hasil', content: '' })
      }
      return arr
    },
    scoreItemHeaders() {
      const arrScoreItemHeaders = [
        {
          text: 'Status',
          value: 'status',
          align: 'left',
          sortable: false
        }
        // {
        //   text: 'No',
        //   value: 'no',
        //   align: 'left',
        //   sortable: false
        // }
        // {
        //   text: 'Kategori',
        //   value: 'category_name',
        //   align: 'left',
        //   sortable: false
        // },
      ]
      // if (this.detailData.audit_type.id == 2) {
      //   arrScoreItemHeaders.push({
      //     text: 'Area',
      //     value: 'area',
      //     align: 'left',
      //     sortable: false
      //   })
      // }
      // if (this.detailData.audit_type.id == 1) {
      //   arrScoreItemHeaders.push({
      //     text: 'Scope',
      //     value: 'scope',
      //     align: 'left',
      //     sortable: false
      //   })
      // }
      arrScoreItemHeaders.push({
        text: 'Klausul',
        value: 'clause_desc',
        align: 'left',
        sortable: false
      })
      if (this.detailData.audit_type.id == 2) {
        arrScoreItemHeaders.push(
          {
            text: '1',
            value: 'very_bad',
            align: 'center',
            sortable: false
          },
          {
            text: '2',
            value: 'bad',
            align: 'center',
            sortable: false
          },
          {
            text: '3',
            value: 'enough',
            align: 'center',
            sortable: false
          },
          {
            text: '4',
            value: 'good',
            align: 'center',
            sortable: false
          },
          {
            text: '5',
            value: 'very_good',
            align: 'center',
            sortable: false
          }
        )
      }
      if (this.detailData.audit_type.id == 1) {
        arrScoreItemHeaders.push(
          {
            text: 'No Klausul',
            value: 'clause_no',
            align: 'left',
            sortable: false
          },
          {
            text: 'Critical',
            value: 'critical',
            align: 'center',
            sortable: false
          },
          {
            text: 'Major',
            value: 'major',
            align: 'center',
            sortable: false
          },
          {
            text: 'Minor',
            value: 'minor',
            align: 'center',
            sortable: false
          },
          {
            text: 'Observation',
            value: 'observation',
            align: 'center',
            sortable: false
          },
          {
            text: 'Conform',
            value: 'conform',
            align: 'center',
            sortable: false
          }
        )
      }
      arrScoreItemHeaders.push(
        {
          text: 'Bukti Objektif',
          value: 'objective_evidence',
          align: 'left',
          sortable: false
        },
        {
          text: 'Rencana Perbaikan',
          value: 'corrective_plan_desc',
          align: 'left',
          sortable: false
        },
        {
          text: 'Due Date Rencana Perbaikan',
          value: 'corrective_plan_due_date',
          align: 'left',
          sortable: false
        },
        {
          text: 'Due Date Perbaikan',
          value: 'corrective_due_date',
          align: 'left',
          sortable: false
        },
        {
          text: 'Hasil Perbaikan',
          value: 'corrective_evidence',
          align: 'left',
          sortable: false
        },
        {
          text: 'Catatan Verifikasi',
          value: 'verification_note',
          align: 'left',
          sortable: false
        }
        // {
        //   text: 'Status',
        //   value: 'status',
        //   align: 'left',
        //   sortable: false
        // }
        // {
        //   text: 'Actions',
        //   value: 'action',
        //   align: 'left',
        //   sortable: false
        // }
      )

      return arrScoreItemHeaders
    },

    evidenceHeaders() {
      const arrHeaders = [
        {
          text: 'File Name',
          value: 'subject',
          align: 'left',
          sortable: false,
          width: '90%'
        },
        {
          text: 'Action',
          value: 'action',
          align: 'center',
          sortable: false,
          width: '10%'
        }
      ]
      return arrHeaders
    },

    approvalHeaders() {
      const arrHeaders = [
        { text: 'Sequence', value: 'sequence', align: 'left', width: '5%' },
        { text: 'Doc. No', value: 'document_no', align: 'left', width: '10%' },
        { text: 'Model', value: 'table_name', align: 'center', width: '10%' },
        { text: 'User', value: 'approver_user', align: 'center', width: '20%' },
        {
          text: 'Min. Approver',
          value: 'min_approver',
          align: 'center',
          width: '5%'
        },
        {
          text: 'Approved by',
          value: 'approved',
          align: 'center',
          width: '10%'
        },
        {
          text: 'Rejected by',
          value: 'rejected',
          align: 'center',
          width: '10%'
        },
        {
          text: 'Created at',
          value: 'created_at',
          align: 'center',
          width: '15%'
        },
        {
          text: 'Update at',
          value: 'updated_at',
          align: 'center',
          width: '15%'
        }
      ]
      return arrHeaders
    },

    memberHeaders() {
      const arrHeaders = [
        {
          text: 'Nama',
          value: 'employee_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tipe Anggota',
          value: 'member_type',
          align: 'left',
          sortable: false
        }
      ]
      if (this.detailData.audit_type.id == 1) {
        arrHeaders.push({
          text: 'Area Audit',
          value: 'scope_ids',
          align: 'left',
          sortable: false
        })
      }

      if (this.detailData.audit_type.id == 2) {
        arrHeaders.push({
          text: 'Area Audit',
          value: 'area_ids',
          align: 'left',
          sortable: false
        })
      }
      if (
        this.getUserProfile.level.find(
          ({ id }) =>
            id == this.appLevel.adminAudit || id == this.appLevel.administrator
        ) != undefined &&
        this.detailData.status.id == 0
      ) {
        arrHeaders.push({
          text: 'Action',
          value: 'action',
          align: 'left',
          sortable: false
        })
      }
      return arrHeaders
    },
    auditResults() {
      const xArr = [
        {
          employee_name: 'Auditor 1',
          ringkas: '28,0',
          rapi: '43,7',
          resik: '42,0',
          rawat: '21,7',
          rajin: '15,0',
          total: '181,3'
        },
        {
          name: 'Auditor 2',
          ringkas: '26,2',
          rapi: '41,0',
          resik: '41,7',
          rawat: '21,7',
          rajin: '15,0',
          total: '178,5'
        },
        {
          name: 'Auditor 3',
          ringkas: '27,7',
          rapi: '41,7',
          resik: '42,3',
          rawat: '19,0',
          rajin: '15,0',
          total: '180,7'
        }
      ]
      return xArr
    }
  },
  watch: {
    search(val) {
      if (val !== '') {
        val && val !== this.select && this.querySelections(val)
      } else {
        this.select = null
        this.items = []
      }
    },
    searchEmployee(val) {
      if (val !== '') {
        val && val !== this.selectEmployee && this.querySelectionEmployee(val)
      } else {
        this.selectEmployee = null
        this.dropdown.employee = []
      }
    },

    selectedData() {
      if (this.detailData != null) {
        if (this.selectedData.length > 0) {
          const xSlc = this.selectedData
          this.itemsAction = [{ id: 0, name: '' }]
          if (this.detailData.status.id == 0) {
            if (
              this.getUserProfile.level.find(
                ({ id }) =>
                  id == this.appLevel.adminAudit ||
                  id == this.appLevel.administrator
              ) != undefined
            ) {
              console.log('AppLevel>>>', this.appLevel)
              if (xSlc.find(({ status }) => status != 0) == undefined) {
                this.itemsAction.push({ id: 4, name: 'Cancel' })
              }
              if (xSlc.find(({ status }) => status != 3) == undefined) {
                this.itemsAction.push({ id: 3, name: 'Set Draft' })
              }
            }
          }
          if (this.detailData.status.id == 2) {
            if (this.isAdminOrAuditor) {
              this.itemsAction = [
                { id: 0, name: '' }
                // { id: 5, name: 'Delete' }
              ]
              if (xSlc.find(({ status }) => status == 3) == undefined) {
                this.itemsAction.push({ id: 4, name: 'Cancel' })
              }

              if (xSlc.find(({ status }) => status != 1) == undefined) {
                this.itemsAction.push({ id: 2, name: 'Verify' })
              }

              if (xSlc.find(({ status }) => status != 3) == undefined) {
                this.itemsAction.push({ id: 3, name: 'Set Draft' })
              }

              if (xSlc.find(({ status }) => status != 0) == undefined) {
                this.itemsAction.push({ id: 1, name: 'Submit' })
              }
            }
          }
        }
      }
    },
    // panel(val) {
    //   console.log('Panel>>>>', val)
    // },
    locationTab(val) {
      // console.log('locationTab>>>>', val)
      this.panel = []
    }
  },
  methods: {
    ...mapActions(['menu_access', 'getMenuId']),
    ...mapMutations([
      // /*'setOvertimePageQuery'*/
    ]),
    actionSelect(event) {
      switch (event) {
        case 1:
          this.submitItemScore()
          break
        case 2:
          this.verifyItemScore()
          break
        case 3:
          this.setDraftItemScore()
          break
        case 4:
          this.cancelItemScore()
          break
        // case 5:
        //   this.deleteItemScore()
        //   break
      }
    },
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    showMsgDialog2(pModalType, pStatusMsg, pBtnCancel, pText) {
      let additional = ''
      if (pText !== undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              additional +
              '<br/>' +
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            confirmButtonText: 'Submit',
            cancelButtonText: 'No',
            input: 'textarea',
            inputLabel:
              'Tolong isi keterangan pada kolom dibawah sebelum submit',
            inputPlaceholder: 'Tulis disini...',
            inputAttributes: {
              'aria-label': 'Tulis disini'
            }
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    areaWatcher() {
      setTimeout(() => {
        this.getDataFromApi()
      }, 200)
    },
    scopeWatcher() {
      setTimeout(() => {
        this.getDataFromApi()
      }, 200)
    },
    clauseWatcher(xV) {
      console.log(xV)
    },
    async initDropdown() {
      this.getDropdownCompany()
      this.dropdownAuditType()
      this.dropdownArea()
      this.dropdownScope()
      this.dropdownFormTemplate()
      // this.dropdownDepartment()
    },
    async getDropdownCompany() {
      if (this.userLevel !== null) {
        // if (this.userLevel.is_admin !== null) {
        if (this.userLevel.user_user_level !== null) {
          if (
            this.userLevel.user_user_level.allowed_company === null ||
            this.userLevel.user_user_level.allowed_company.length === 0
          ) {
            this.dropdownCompanyApi()
          } else {
            this.dropdown.company =
              this.userLevel.user_user_level.allowed_company
            this.isDisableCompanyDropdown = false
          }
        } else {
          this.dropdownCompanyApi()
        }
        // }
      }
      // else {
      //   this.dropdownCompanyApi()
      // }
    },
    async dropdownCompanyApi() {
      if (Number(this.getUserProfile.employee.company.plant_id) !== 6) {
        this.isDisableCompanyDropdown = this.userLevel.is_support
      } else {
        this.isDisableCompanyDropdown = false
      }
      axios
        .get(`${this.eSanqua}master/universal/plant/dropdown`)
        .then((res) => {
          this.dropdown.company = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },

    async dropdownAuditType() {
      await axios
        .get(`${this.dssApi}master/universal/audittype/dropdown`)
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.auditType = res.data.data)
          }
          return (this.dropdown.auditType = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.auditType = [])
        })
    },

    async dropdownArea() {
      let url = `${this.dssApi}master/universal/area/dropdown`
      const filter = []
      if (this.detailData != null && this.detailData.company != null) {
        filter.push(`{"company_ids": ${this.detailData.company.id}}`)
      }
      url = url + `?filter=[${filter}]`
      await axios
        .get(url)
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.area = res.data.data)
          }
          return (this.dropdown.area = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.area = [])
        })
    },

    async dropdownScope() {
      let url = `${this.dssApi}master/universal/scope/dropdown`
      const filter = []
      if (this.detailData != null && this.detailData.company != null) {
        filter.push(`{"company_ids": ${this.detailData.company.id}}`)
      }
      url = url + `?filter=[${filter}]`
      await axios
        .get(url)
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.scope = res.data.data)
          }
          return (this.dropdown.scope = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.scope = [])
        })
    },
    async dropdownFormTemplate() {
      let url = `${this.dssApi}master/universal/formtemplate/dropdown`
      const filter = []
      if (this.detailData != null && this.detailData.company != null) {
        filter.push(`{"company_id": ${this.detailData.company.id}}`)
      }
      if (this.detailData != null && this.detailData.audit_type != null) {
        filter.push(`{"audit_type_id": ${this.detailData.audit_type.id}}`)
      }

      url = url + `?filter=[${filter}]`
      await axios
        .get(url)
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.template = res.data.data)
          }
          return (this.dropdown.template = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.template = [])
        })
    },
    querySelections(v) {
      console.log(v, v.length)
      let url = `${this.dssApi}master/universal/clause/dropdown?keyword=${v}&join_table=[{"name":"clausecategory","alias":"clause_category"}]`
      const filter = []
      if (this.detailData.company_id !== null) {
        filter.push(`{"company_ids": ${this.detailData.company_id}}`)
      }
      if (this.detailData.audit_type_id !== null) {
        filter.push(`{"audit_type_id": ${this.detailData.audit_type_id}}`)
      }
      if (this.form.area_id) {
        filter.push(`{"area_ids": ${this.form.area_id}}`)
      }
      if (this.form.scope_id) {
        filter.push(`{"scope_ids": ${this.form.scope_id}}`)
      }
      url = url + `&filter=[${filter}]`
      axios
        .get(url)
        .then((res) => {
          console.log(res)
          if (res.data.status_code === '00') {
            return (this.clauseList = res.data.data)
          }
          return (this.clauseList = [])
        })
        .catch((err) => {
          this.clauseList = []
          return console.log(err)
        })
    },

    async getDataMenu() {
      this.isLoadingPage = true
      const split = this.$route.path.split('/')
      const routeModule = '/' + split[1] + '/' + split[2]
      console.log('Path>>>>>', routeModule)
      await this.getMenuId({
        keyword: '',
        path: routeModule
      })
        .then((result) => {
          if (result.data.status_code === '00') {
            const menuId = result.data.data[0].id
            this.userLevel = this.getUserProfile.level.find(
              ({ application }) =>
                application.id === this.config.application.dss.applicationId ||
                application.id === this.config.application.all.applicationId
            )
            // console.log('userLevel>>>>>', this.userLevel)
            if (this.userLevel !== null) {
              if (
                this.getUserProfile.level.find(
                  ({ id }) => id == this.appLevel.administrator
                ) !== undefined
              ) {
                this.resetPermission({
                  data: {
                    read_perm: 1,
                    create_perm: 1,
                    update_perm: 1,
                    delete_perm: 1
                  }
                })
              } else {
                this.checkMenuAccess([menuId, this.userLevel.id])
              }
            } else {
              this.resetPermission(null)
            }
          } else {
            this.isLoadingPage = false
          }
        })
        .catch((err) => {
          console.log(err)
          this.isLoadingPage = false
        })
    },
    async checkMenuAccess(payload) {
      await this.menu_access(payload)
        .then((result) => {
          console.log('menuAccess>>>>', result)
          this.resetPermission(result)
        })
        .catch((err) => {
          console.log(err)
          this.resetPermission(null)
        })
    },
    resetPermission(val) {
      this.permission = null

      if (val !== null) {
        if (val.data !== null) {
          if (val.data.read_perm === 1) {
            this.permission = val.data
            this.initDataForLayout()
          }
        }
      }
      this.isLoadingPage = false
    },
    async initDataForLayout() {
      if (this.userLevel.is_support) {
        this.paramAPI.company_id = {
          id: 0,
          name: ''
        }
      } else {
        this.paramAPI.company_id = {
          id: Number(this.getUserProfile.employee.company.plant_id),
          name: this.getUserProfile.employee.company.name
        }
      }

      // if (
      //   this.getUserProfile.level.find(
      //     ({ id }) => id == this.appLevel.adminMaster
      //   ) !== undefined
      // ) {
      //   this.paramAPI.mode = ''
      // }
      // this.paramAPI.department_id = this.getUserProfile.employee.department_id

      // if (this.getOvertimePageQuery !== null) {
      //   this.paramAPI = this.getOvertimePageQuery
      // }
      setTimeout(async () => {
        await this.getDataFromApi()
      }, 200)
    },
    async getDataFromApi() {
      this.loading = true
      // this.panel = []
      // this.locationTab = null
      this.locationTabItems = []
      this.scoreItem = null
      const url = `${this.dssApi}audit/detail/${this.$route.params.id}`
      await axios
        .get(url)
        .then((res) => {
          console.log('Detaill >>>', res)
          if (res.data.status_code == '00') {
            // this.loading = false
            this.detailData = res.data.data
            if (this.detailData.status.id == 1) {
              this.authorityCheck(res.data.data)
            }
            const auditItemScore = this.detailData.audit_item_score
            const newArrItem = []

            if (auditItemScore.length > 0) {
              for (let i = 0; i < auditItemScore.length; i++) {
                let corrective_due_date = null
                let corrective_plan_due_date = null
                if (auditItemScore[i].corrective_due_date) {
                  corrective_due_date = moment(
                    auditItemScore[i].corrective_due_date
                  ).format('YYYY-MM-DD')
                }
                if (auditItemScore[i].corrective_plan_due_date) {
                  corrective_plan_due_date = moment(
                    auditItemScore[i].corrective_plan_due_date
                  ).format('YYYY-MM-DD')
                }
                var objItem = {
                  id: auditItemScore[i].id,
                  clause_id: auditItemScore[i].clause_id,
                  clause_desc: auditItemScore[i].clause_desc,
                  clause_no: auditItemScore[i].clause_no,
                  category_id: auditItemScore[i].category_id,
                  category_name: auditItemScore[i].category_name,
                  area: auditItemScore[i].area,
                  scope: auditItemScore[i].scope,
                  company_id: auditItemScore[i].company_id,
                  corrective_due_date: corrective_due_date,
                  corrective_evidence: auditItemScore[i].corrective_evidence,
                  corrective_plan_desc: auditItemScore[i].corrective_plan_desc,
                  corrective_plan_due_date: corrective_plan_due_date,
                  objective_evidence: auditItemScore[i].objective_evidence,
                  score: {
                    id: auditItemScore[i].score_id,
                    name: auditItemScore[i].score_name,
                    value: auditItemScore[i].score_value
                  },
                  score_id: auditItemScore[i].score_id,
                  score_name: auditItemScore[i].score_name,
                  score_value: auditItemScore[i].score_value,
                  status: auditItemScore[i].status,
                  verification_note: auditItemScore[i].verification_note,
                  cancel_note: auditItemScore[i].cancel_note,
                  // is_score_double: auditItemScore[i].is_score_double,
                  score_multiplier: auditItemScore[i].score_multiplier,
                  submit_at: auditItemScore[i].submit_at,
                  submit_by: auditItemScore[i].submit_by,
                  submit_by_name: auditItemScore[i].submit_by_name,
                  verify_at: auditItemScore[i].verify_at,
                  verify_by: auditItemScore[i].verify_by,
                  verify_by_name: auditItemScore[i].verify_by_name,
                  cancel_at: auditItemScore[i].cancel_at,
                  cancel_by: auditItemScore[i].cancel_by,
                  cancel_by_name: auditItemScore[i].cancel_by_name
                }
                newArrItem.push(objItem)
              }
            }
            this.checkIsAdminOrAuditor()
            this.checkIsAuditee()
            this.groupedByAreaAndCategory(newArrItem)
            // this.$nextTick(() => {
            this.getDiscoveryItems(null)
            this.initDropdown()
            // });
          } else {
            this.loading = false
            // this.showMsgDialog('error', res.data.status_msg, false)
          }
          return null
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
          return null
        })
    },
    async groupedByAreaAndCategory(arrItem) {
      const member = this.detailData.audit_member.find(
        ({ employee_id }) => employee_id == this.getUserProfile.employee.id
      )
      let xItemList = arrItem
      if (this.detailData.audit_type.id == 1) {
        if (
          this.getUserProfile.level.find(
            ({ id }) => id == this.appLevel.picAudit
          ) != undefined
        ) {
          if (!this.isAuditee) {
            if (member != undefined) {
              if (member.member_type == 1) {
                xItemList = await xItemList.filter((item) =>
                  member.scope_ids.includes(item.scope.id)
                )
              }
            }
          }
        }

        if (this.paramAPI.scope != null) {
          xItemList = await xItemList.filter(
            (item) => item.scope.id == this.paramAPI.scope
          )
        }
      }
      if (this.detailData.audit_type.id == 2) {
        if (
          this.getUserProfile.level.find(
            ({ id }) => id == this.appLevel.picAudit
          ) != undefined
        ) {
          if (!this.isAuditee) {
            if (member != undefined) {
              if (member.member_type == 1) {
                xItemList = await xItemList.filter((item) =>
                  member.area_ids.includes(item.area.id)
                )
              }
            }
          }
        }

        if (this.paramAPI.area != null) {
          xItemList = await xItemList.filter(
            (item) => item.area.id == this.paramAPI.area
          )
        }
      }
      console.log('xItemList>>>', xItemList)

      if (xItemList.length > 0) {
        const grouped = await xItemList.reduce((acc, item) => {
          let locationName = '-'

          if (this.detailData.audit_type.id == 1) {
            locationName = item.scope?.name || '-'
          }
          if (this.detailData.audit_type.id == 2) {
            locationName = item.area?.name || '-'
          }

          const categoryName = item.category_name || '-'

          // Initialize area if it doesn't exist
          if (!acc[locationName]) {
            acc[locationName] = {}
          }

          // Initialize category inside area if it doesn't exist
          if (!acc[locationName][categoryName]) {
            acc[locationName][categoryName] = []
          }

          // Push item into the correct category under the correct area
          acc[locationName][categoryName].push(item)

          return acc
        }, {})

        Object.keys(grouped).forEach((areaName) => {
          const categories = grouped[areaName]

          Object.keys(categories).forEach((categoryName) => {
            categories[categoryName].sort((a, b) =>
              a.clause_desc.localeCompare(b.clause_desc)
            )
          })
        })

        // console.log('grouped>>>', grouped)
        // console.log(grouped['Area Security']['Ringkas']) // eslint-disable-line dot-notation
        // get audit item tab object
        // console.log('groupedSort>>>', Object.keys(grouped).sort())
        for (let i = 0; i < Object.keys(grouped).sort().length; i++) {
          this.locationTabItems.push({
            tab: Object.keys(grouped).sort()[i],
            content: ''
          })
        }
        // console.log('1>>>>>>', Object.keys(grouped[Object.keys(grouped)[0]]))
        // all expension panell on active state
        // for (
        //   let j = 0;
        //   j < Object.keys(grouped[Object.keys(grouped)[0]]).length;
        //   j++
        // ) {
        //   this.panel.push(j);
        // }

        console.log('grouped>>>', grouped)
        setTimeout(() => {
          this.scoreItem = grouped
          this.loading = false
          // console.log('scoreItem>>>', this.scoreItem)
        }, 100)
      } else {
        this.scoreItem = null
        this.loading = false
      }
    },
    authorityCheck(item) {
      if (item.approval_matrix !== null) {
        const matrixId = item.approval_matrix[0].document_id
        axios
          .get(
            `${this.oAuthApi}approval_matrix/document/allow_user?document_id=${matrixId}&application_id=23&table_name=tr_audits`
          )
          .then((res) => {
            console.log('AuthorityCheck>>>', res)

            if (res.data.status_code === '00') {
              if (res.data.is_allow_approve !== 0) {
                this.isAllowApprove = true
              } else {
                this.isAllowApprove = false
              }
            } else {
              this.isAllowApprove = false
            }
          })
          .catch((err) => {
            this.showMsgDialog(
              'error',
              err
                ? 'Cek Otoritas error, Silahkan info ke Admin'
                : 'Cek Otoritas error, Silahkan info ke Admin',
              false
            )
          })
      }
    },
    async fetchMatrix() {
      this.loading = true
      const form = {
        id: this.$route.params.id
        // approval_matrix_id: this.detailData.approval_matrix[0].document_id
      }
      await axios
        .post(`${this.dssApi}audit/fetch_matrix`, form)
        .then(async (res) => {
          if (res.data.status_code == '00') {
            if (res.data.approval_matrix_result.status_code == '00') {
              this.getDataFromApi()
            } else {
              this.showMsgDialog(
                'warning',
                res.data.approval_matrix_result.status_msg,
                false
              )
            }
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
          }
          this.loading = false
          this.showMsgDialog(
            res.data.status_code == '00' ? 'success' : 'warning',
            res.data.status_msg,
            false
          )
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
        })
    },
    enableEdit() {
      this.isEdit = !this.isEdit

      if (!this.isEdit) {
        this.getDataFromApi()
      }
    },

    saveForm() {
      this.rules.nameRules = [(v) => !!v || 'Name is required']
      this.rules.companyRules = [(v) => !!v || 'Company is required']
      this.rules.auditTypeRules = [(v) => !!v || 'Audit Type is required']
      this.rules.templateRules = [(v) => !!v || 'Template is required']

      const self = this
      setTimeout(function () {
        if (self.$refs.entryForm.validate()) {
          const form = {
            act: 'update',
            id: self.detailData.id,
            name: self.detailData.name,
            company_id: self.detailData.company.id,
            company_name: self.detailData.company.name,
            audit_type_id:
              self.detailData.audit_type != null
                ? self.detailData.audit_type.id
                : null,
            audit_date: self.detailData.audit_date,
            template_id:
              self.detailData.template != null
                ? self.detailData.template.id
                : null
          }

          if (self.detailData.department != null) {
            Object.assign(form, {
              department_id: self.detailData.department_id,
              department_name: self.detailData.department_name
            })
          }

          self.submitForm(form)
        }
      })
    },
    async submitForm(form) {
      console.log(form)
      await axios
        .post(`${this.dssApi}audit/save`, form)
        .then(async (res) => {
          console.log(res.data)
          if (res.data.status_code !== '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.enableEdit()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    closeDetailAudit() {
      this.detailData = null
      this.scoreItem = null
      this.isEdit = false
      setTimeout(() => {
        this.$router.push('/dss/audit/list')
      }, 300)
    },
    submitAuditDocument() {
      this.showMsgDialog(
        'question',
        'Anda yakin ingin submit dokumen ini ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.$route.params.id
          }
          axios
            .post(`${this.dssApi}audit/submit`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                this.selectedData = []
                this.showMsgDialog('success', res.data.status_msg, false)
                // if (this.detailData.approval_matrix !== null) {
                //   await this.fetchMatrix()
                // } else {
                this.getDataFromApi()
                // }
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },
    confirmAuditDocument() {
      this.showMsgDialog2('question', 'Confirm dokumen ini ?', true).then(
        async (res) => {
          if (res.isConfirmed) {
            this.loading = true
            const form = {
              document_id: this.$route.params.id,
              note: res.value
            }
            axios
              .post(`${this.dssApi}audit/approve`, form)
              .then(async (res) => {
                this.loading = false
                if (res.data.status_code == '00') {
                  this.showMsgDialog('success', res.data.status_msg, false)
                  this.getDataFromApi()
                  // if (this.detailData.approval_matrix !== null) {
                  //   await this.fetch()
                  //   console.log('fetch done')
                  // } else {
                  //   this.getDataFromApi()
                  // }
                } else {
                  this.showMsgDialog('warning', res.data.status_msg, false)
                }
              })
              .catch((err) => {
                this.showMsgDialog('error', err, false)
                this.loading = false
              })
          }
        }
      )
    },
    rejectAuditDocument() {
      this.showMsgDialog2('question', 'Confirm dokumen ini ?', true).then(
        async (res) => {
          if (res.isConfirmed) {
            this.loading = true
            const form = {
              document_id: this.$route.params.id,
              note: res.value
            }
            axios
              .post(`${this.dssApi}audit/reject`, form)
              .then(async (res) => {
                this.loading = false
                if (res.data.status_code == '00') {
                  this.showMsgDialog('success', res.data.status_msg, false)
                  this.getDataFromApi()
                  // if (this.detailData.approval_matrix !== null) {
                  //   await this.fetch()
                  //   console.log('fetch done')
                  // } else {
                  //   this.getDataFromApi()
                  // }
                } else {
                  this.showMsgDialog('warning', res.data.status_msg, false)
                }
              })
              .catch((err) => {
                this.showMsgDialog('error', err, false)
                this.loading = false
              })
          }
        }
      )
    },
    doneAuditDocument() {
      this.showMsgDialog(
        'question',
        'Update dokumen menjadi DONE ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.$route.params.id
            // note: res.value
          }
          axios
            .post(`${this.dssApi}audit/done`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                this.selectedData = []
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
                // if (this.detailData.approval_matrix !== null) {
                //   await this.fetch()
                //   console.log('fetch done')
                // } else {
                //   this.getDataFromApi()
                // }
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },
    cancelAuditDocument() {
      this.showMsgDialog2(
        'question',
        'Anda yakin ingin cancel dokumen ini ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.$route.params.id,
            note: res.value
          }
          axios
            .post(`${this.dssApi}audit/cancel`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                this.selectedData = []
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
                // if (this.detailData.approval_matrix !== null) {
                //   await this.fetch()
                //   console.log('fetch done')
                // } else {
                //   this.getDataFromApi()
                // }
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },
    setDraftAuditDocument() {
      this.showMsgDialog(
        'question',
        'Anda yakin ingin SET DRAFT dokumen ini ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.$route.params.id
            // note: res.value
          }
          axios
            .post(`${this.dssApi}audit/set_to_draft`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                this.selectedData = []
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
                // if (this.detailData.approval_matrix !== null) {
                //   await this.fetch()
                //   console.log('fetch done')
                // } else {
                //   this.getDataFromApi()
                // }
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },
    async updateScore(item) {
      const xForm = {
        act: 'update',
        id: item.id,
        score_id: item.score.id,
        score_name: item.score.name,
        score_value: item.score.value
      }
      // console.log('updateScore>>>', xForm)
      await axios
        .post(`${this.dssApi}audit/item/save`, xForm)
        .then(async (res) => {
          console.log(res.data)
          if (res.data.status_code !== '00') {
            // this.showMsgDialog('success', res.data.status_msg, false)
            // this.getDataFromApi()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    async updateCorrectiveDueDate(item) {
      const xForm = {
        act: 'update',
        id: item.id,
        corrective_due_date: item.corrective_due_date
      }
      // console.log('updateScore>>>', xForm)
      await axios
        .post(`${this.dssApi}audit/item/save`, xForm)
        .then(async (res) => {
          console.log(res.data)
          if (res.data.status_code !== '00') {
            // this.showMsgDialog('success', res.data.status_msg, false)
            // this.getDataFromApi()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    async updateCorrectivePlanDueDate(item) {
      const xForm = {
        act: 'update',
        id: item.id,
        corrective_plan_due_date: item.corrective_plan_due_date
      }
      // console.log('updateScore>>>', xForm)
      await axios
        .post(`${this.dssApi}audit/item/save`, xForm)
        .then(async (res) => {
          console.log(res.data)
          if (res.data.status_code !== '00') {
            // this.showMsgDialog('success', res.data.status_msg, false)
            // this.getDataFromApi()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    async updateCorrectivePlanDesc() {
      const xForm = {
        act: 'update',
        id: this.correctivePlanDesc.id,
        corrective_plan_desc: this.correctivePlanDesc.corrective_plan_desc
      }
      console.log('updateCorrectivePlanDesc>>>', xForm)
      await axios
        .post(`${this.dssApi}audit/item/save`, xForm)
        .then(async (res) => {
          console.log(res.data)
          if (res.data.status_code !== '00') {
            // this.showMsgDialog('success', res.data.status_msg, false)
            // this.getDataFromApi()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }

          this.correctivePlanDialog = false
          this.correctivePlanDesc = null
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )

          this.correctivePlanDialog = false
          this.correctivePlanDesc = null
        })
    },
    async updateVerificationNote() {
      const xForm = {
        act: 'update',
        id: this.verificationNote.id,
        verification_note: this.verificationNote.verification_note
      }
      console.log('updateVerificationNote>>>', xForm)
      await axios
        .post(`${this.dssApi}audit/item/save`, xForm)
        .then(async (res) => {
          console.log(res.data)
          if (res.data.status_code !== '00') {
            // this.showMsgDialog('success', res.data.status_msg, false)
            // this.getDataFromApi()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }

          this.correctivePlanDialog = false
          this.correctivePlanDesc = null
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )

          this.verificationNoteDialog = false
          this.verificationNote = null
        })
    },
    scoreItemRowClick(pItem) {
      console.log('edit clause', pItem)

      // this.form = {
      //   act: 'update',
      //   id: pItem.id,
      //   clause: {
      //     id: pItem.clause_id,
      //     description: pItem.clause_desc,
      //     clause_no: pItem.clause_no,
      //     reference: pItem.clause_ref,
      //     clause_category: {
      //       id: pItem.clause_category_id,
      //       name: pItem.clause_category_name
      //     }
      //   },
      //   area_id: null,
      //   scope_id: null
      // }
      // setTimeout(() => {
      //   this.formClauseDialog = !this.formClauseDialog
      // }, 300)
    },
    // saveClause() {
    //   console.log('here')

    //   this.rules.clauseRules = [(v) => !!v || 'Klausul is required']
    //   const self = this
    //   setTimeout(function () {
    //     if (self.$refs.entryForm2.validate()) {
    //       const form = {
    //         act: self.form.act,
    //         clause_id: self.form.clause.id
    //       }

    //       if (self.form.act == 'add') {
    //         Object.assign(form, {
    //           formtemplate_id: self.form.formtemplate_id
    //         })
    //       }

    //       if (self.form.act == 'update') {
    //         Object.assign(form, {
    //           id: self.form.id
    //         })
    //       }

    //       if (self.detailData.audit_type_id == 1) {
    //         Object.assign(form, {
    //           scope_id: self.form.scope_id
    //         })
    //       }

    //       if (self.detailData.audit_type_id == 2) {
    //         Object.assign(form, {
    //           area_id: self.form.area_id
    //         })
    //       }

    //       self.submitClause(form)
    //     }
    //   })
    // },
    // async submitClause(form) {
    //   console.log(form)
    //   await axios
    //     .post(`${this.dssApi}formtemplate/item/save`, form)
    //     .then(async (res) => {
    //       console.log(res.data)
    //       if (res.data.status_code !== '-99') {
    //         this.showMsgDialog('success', res.data.status_msg, false)
    //         // this.enableEdit()
    //         this.closeClauseDialog()
    //         this.getDataFromApi()
    //       } else {
    //         if (res.data.status_msg === 'Parameter value has problem') {
    //           this.showMsgDialog(
    //             'warning',
    //             'Invalid input, Parameter value has problem',
    //             false
    //           )
    //         } else {
    //           this.showMsgDialog('warning', res.data.status_msg, false)
    //         }
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //       this.showMsgDialog(
    //         'error',
    //         err
    //           ? 'Something went wrong, Please contact an admin!'
    //           : 'Something went wrong, Please contact an admin!',
    //         false
    //       )
    //     })
    // },
    // closeClauseDialog() {
    //   this.formClauseDialog = !this.formClauseDialog
    //   setTimeout(() => {
    //     this.form = null
    //   }, 300)
    // },
    scoreItemDisabled(pItem) {
      this.showMsgDialog(
        'question',
        'Are you sure, This data will be deleted',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          // await axios
          //   .delete(`${this.dssApi}audit/item/delete/${pItem.id}`)
          //   .then(async (res) => {
          //     if (res.data.status_code !== '-99') {
          //       this.showMsgDialog('success', res.data.status_msg, false)
          //       this.getDataFromApi()
          //     } else {
          //       this.showMsgDialog('warning', res.data.status_msg, false)
          //     }
          //   })
          //   .catch((err) => {
          //     console.log(err)
          //     this.showMsgDialog(
          //       'error',
          //       err
          //         ? 'Something went wrong, Please contact an admin!'
          //         : 'Something went wrong, Please contact an admin!',
          //       false
          //     )
          //   })
        }
      })
    },
    async submitItemScore() {
      this.showMsgDialog(
        'question',
        `Submit ${this.selectedData.length} item yang dipilih ?`,
        true
      ).then(async (res) => {
        let successCount = 0
        let failCount = 0
        if (res.isConfirmed) {
          this.loading = true
          for (let i = 0; i < this.selectedData.length; i++) {
            await axios
              .post(`${this.dssApi}audit/item/submit`, {
                id: this.selectedData[i].id
              })
              .then((res) => {
                if (res.data.status_code === '00') {
                  successCount = successCount + 1
                } else {
                  failCount = failCount + 1
                }
                return null
              })
              .catch((err) => {
                console.log(err)
                failCount = failCount + 1
                return null
              })
          }

          this.actionValue = 0
          this.selectedData = []
          const additionalHtml =
            '<span>' +
            'Finish' +
            '</span>' +
            '<br/>' +
            '<span>' +
            `Submit berhasil = ${successCount}` +
            '</span>' +
            '<br/>' +
            '<span>' +
            `Submit gagal = ${failCount}` +
            '</span>'
          this.showMsgDialog('success', additionalHtml, 'false')
          this.getDataFromApi()
          this.loading = false
        } else {
          this.actionValue = 0
        }
      })
    },
    async verifyItemScore() {
      this.showMsgDialog2(
        'question',
        `Verifikasi ${this.selectedData.length} item yang dipilih ?`,
        true
      ).then(async (res) => {
        let successCount = 0
        let failCount = 0
        if (res.isConfirmed) {
          this.loading = true
          for (let i = 0; i < this.selectedData.length; i++) {
            await axios
              .post(`${this.dssApi}audit/item/verify`, {
                id: this.selectedData[i].id,
                verification_note: res.value
              })
              .then((res) => {
                if (res.data.status_code === '00') {
                  successCount = successCount + 1
                } else {
                  failCount = failCount + 1
                }
                return null
              })
              .catch((err) => {
                console.log(err)
                failCount = failCount + 1
                return null
              })
          }

          this.actionValue = 0
          this.selectedData = []
          const additionalHtml =
            '<span>' +
            'Finish' +
            '</span>' +
            '<br/>' +
            '<span>' +
            `Verifikasi berhasil = ${successCount}` +
            '</span>' +
            '<br/>' +
            '<span>' +
            `Verifikasi gagal = ${failCount}` +
            '</span>'
          this.showMsgDialog('success', additionalHtml, 'false')
          this.getDataFromApi()
          this.loading = false
        } else {
          this.actionValue = 0
        }
      })
    },
    async setDraftItemScore() {
      this.showMsgDialog(
        'question',
        `Set draft ${this.selectedData.length} item yang dipilih ?`,
        true
      ).then(async (res) => {
        let successCount = 0
        let failCount = 0
        if (res.isConfirmed) {
          this.loading = true
          for (let i = 0; i < this.selectedData.length; i++) {
            await axios
              .post(`${this.dssApi}audit/item/set_to_draft`, {
                id: this.selectedData[i].id
              })
              .then((res) => {
                if (res.data.status_code === '00') {
                  successCount = successCount + 1
                } else {
                  failCount = failCount + 1
                }
                return null
              })
              .catch((err) => {
                console.log(err)
                failCount = failCount + 1
                return null
              })
          }

          this.actionValue = 0
          this.selectedData = []
          const additionalHtml =
            '<span>' +
            'Finish' +
            '</span>' +
            '<br/>' +
            '<span>' +
            `Set to draft berhasil = ${successCount}` +
            '</span>' +
            '<br/>' +
            '<span>' +
            `Set to draft gagal = ${failCount}` +
            '</span>'
          this.showMsgDialog('success', additionalHtml, 'false')
          this.getDataFromApi()
          this.loading = false
        } else {
          this.actionValue = 0
        }
      })
    },
    async cancelItemScore() {
      this.showMsgDialog2(
        'question',
        `Cancel ${this.selectedData.length} item yang dipilih ?`,
        true
      ).then(async (res) => {
        let successCount = 0
        let failCount = 0
        if (res.isConfirmed) {
          this.loading = true
          for (let i = 0; i < this.selectedData.length; i++) {
            await axios
              .post(`${this.dssApi}audit/item/cancel`, {
                id: this.selectedData[i].id,
                cancel_note: res.value
              })
              .then((res) => {
                if (res.data.status_code === '00') {
                  successCount = successCount + 1
                } else {
                  failCount = failCount + 1
                }
                return null
              })
              .catch((err) => {
                console.log(err)
                failCount = failCount + 1
                return null
              })
          }

          this.actionValue = 0
          this.selectedData = []
          const additionalHtml =
            '<span>' +
            'Finish' +
            '</span>' +
            '<br/>' +
            '<span>' +
            `Cancel berhasil = ${successCount}` +
            '</span>' +
            '<br/>' +
            '<span>' +
            `Cancel gagal = ${failCount}` +
            '</span>'
          this.showMsgDialog('success', additionalHtml, 'false')
          this.getDataFromApi()
          this.loading = false
        } else {
          this.actionValue = 0
        }
      })
    },
    async deleteItemScore() {
      // this.showMsgDialog(
      //   'question',
      //   `Delete ${this.selectedData.length} item yang dipilih ?`,
      //   true
      // ).then(async (res) => {
      //   let successCount = 0
      //   let failCount = 0
      //   if (res.isConfirmed) {
      //     this.loading = true
      //     for (let i = 0; i < this.selectedData.length; i++) {
      //       await axios
      //         .delete(
      //           `${this.dssApi}audit/item/delete/${this.selectedData[i].id}`
      //         )
      //         .then((res) => {
      //           if (res.data.status_code === '00') {
      //             successCount = successCount + 1
      //           } else {
      //             failCount = failCount + 1
      //           }
      //           return null
      //         })
      //         .catch((err) => {
      //           console.log(err)
      //           failCount = failCount + 1
      //           return null
      //         })
      //     }
      //     this.actionValue = 0
      //     const additionalHtml =
      //       '<span>' +
      //       'Finish' +
      //       '</span>' +
      //       '<br/>' +
      //       '<span>' +
      //       `Delete berhasil = ${successCount}` +
      //       '</span>' +
      //       '<br/>' +
      //       '<span>' +
      //       `Delete gagal = ${failCount}` +
      //       '</span>'
      //     this.showMsgDialog('success', additionalHtml, 'false')
      //     this.getDataFromApi()
      //     this.loading = false
      //   } else {
      //     this.actionValue = 0
      //   }
      // })
    },
    regenerateForm() {
      this.showMsgDialog(
        'warning',
        'Data sebelumnya akan hilang. Anda yakin ingin generate semua klausul sekarang ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          const form = {
            audit_id: this.detailData.id,
            audit_type_id: this.detailData.audit_type.id,
            company_id: this.detailData.company.id,
            template_id:
              this.detailData.template != null ? this.detailData.template.id : 0
          }
          console.log(form)

          await axios
            .post(`${this.dssApi}audit/generate_form`, form)
            .then(async (res) => {
              if (res.data.status_code !== '-99') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              console.log(err)
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    openCorrectivePlanDialog(obj) {
      console.log(obj)
      this.correctivePlanDesc = obj
      setTimeout(() => {
        this.correctivePlanDialog = true
      }, 100)
    },
    closeCorrectivePlanDialog() {
      this.correctivePlanDialog = false
      setTimeout(() => {
        this.correctivePlanDesc = null
      }, 100)
    },
    openVerificationNoteDialog(obj) {
      console.log(obj)
      this.verificationNote = obj
      setTimeout(() => {
        this.verificationNoteDialog = true
      }, 100)
    },
    closeVerificationNoteDialog() {
      this.verificationNoteDialog = false
      setTimeout(() => {
        this.verificationNote = null
      }, 100)
    },
    openEvidenceDialog(id, obj, title, itemStatus, tabObj) {
      console.log('Open Evidence Dialog>>>>', obj, title)

      setTimeout(() => {
        this.auditItemId = id
        this.evidenceTitleModal = title
        this.evidenceFile = obj
        this.auditItemStatus = itemStatus
      }, 10)
      setTimeout(() => {
        this.canAccessItemUpload(tabObj)
      }, 100)
      setTimeout(() => {
        this.evidenceDialog = true
      }, 300)
    },
    closeEvidenceDialog() {
      this.evidenceDialog = false
      setTimeout(() => {
        this.evidenceTitleModal = ''
        this.evidenceFile = null
        this.auditItemId = null
        this.auditItemStatus = null
        this.isCanAccessItemUpload = false
      }, 300)
    },
    unlinkDokumen(fName, pValue) {
      console.log('Unlink>>>', fName)

      this.loading = true
      const data = {
        module: 'audit',
        file_name: fName
      }
      axios
        .post(`${this.uploadApi}esanqua/dss/unlink`, data)
        .then((res) => {
          console.log('Unlink>>>>>', res)

          if (res.data.status_code === '00') {
            this.fileName = ''
            if (pValue === undefined) {
              this.removeFileFromDetail(fName)
            }
          } else {
            this.showMsgDialog('warning', res.data.status_msg, false)
            if (pValue === undefined) {
              if (res.data.status_msg === 'File not found') {
                this.removeFileFromDetail(fName)
              }
            }
          }
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          this.showMsgDialog('error', err.message, false)
        })
    },
    removeFileFromDetail(fName) {
      console.log('removeFileFromDetail>>', fName, this.evidenceFile)

      for (let i = 0; i < this.evidenceFile.length; i++) {
        if (this.evidenceFile[i].file.includes(fName)) {
          this.evidenceFile.splice(i, 1)
        }
      }
      console.log('this.evidenceFil after>>', this.evidenceFil)
      this.updatePhoto(false)
    },
    async updatePhoto(isAddFile) {
      // this.loading = true
      console.log('upload form>>>', this.evidenceFile)
      const file = []
      if (this.evidenceFile != null) {
        for (let i = 0; i < this.evidenceFile.length; i++) {
          const fName = this.evidenceFile[i].file.slice(
            this.evidenceFile[i].file.lastIndexOf('/') + 1
          )
          file.push({
            subject: this.evidenceFile[i].subject,
            file: fName
          })
        }
      }
      if (isAddFile) {
        file.push({
          subject: this.file_subject,
          file: this.fileName
        })
      }
      const form = {
        id: this.auditItemId
      }
      if (this.evidenceTitleModal == 'Objective') {
        Object.assign(form, {
          objective_evidence: file
        })
      }
      if (this.evidenceTitleModal == 'Corrective') {
        Object.assign(form, {
          corrective_evidence: file
        })
      }
      console.log('upload form>>>', form)
      await axios
        .post(`${this.dssApi}audit/item/update_file_upload`, form)
        .then((res) => {
          this.loading = false
          if (res.data.status_code === '00') {
            this.showMsgDialog('success', 'File berhasil disimpan', false)
            this.file_subject = null
            this.fileName = ''
            if (document.getElementById('closeFileUpload') != null) {
              document.getElementById('closeFileUpload').click()
            }
            this.evidenceFile = []
            setTimeout(() => {
              for (let i = 0; i < file.length; i++) {
                this.evidenceFile.push({
                  subject: file[i].subject,
                  file: 'http://10.10.20.8:8020/dss/audit/' + file[i].file
                })
              }
              console.log('this.evidenceFile>>>>', this.evidenceFile)

              this.getDataFromApi()
            }, 300)
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
            this.unlinkDokumen(this.fileName)
          }
        })
        .catch((err) => {
          this.loading = false
          this.showMsgDialog('error', err.message, false)
          this.fileName = ''
          // this.$refs.entryFormUpload.reset()
        })
    },
    async deleteAllFile() {
      this.showMsgDialog(
        'question',
        'Semua file akan terhapus, Anda yakin ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          // this.loading = true
          const arrFileName = []
          for (let i = 0; i < this.evidenceFile.length; i++) {
            const fileName = this.evidenceFile[i].file.slice(
              this.evidenceFile[i].file.lastIndexOf('/') + 1
            )
            const data = {
              module: 'audit',
              file_name: fileName
            }
            await axios
              .post(`${this.uploadApi}esanqua/dss/unlink`, data)
              .then((res) => {
                console.log(`Unlink-${i + 1}>>>`, res)

                if (res.data.status_code === '00') {
                  arrFileName.push(fileName)
                }
                return null
              })
              .catch((err) => {
                console.log(`Err Unlink-${i + 1}>>>`, err)
                return null
              })
          }
          console.log('deleteAll>>>>>', arrFileName)

          const form = {
            id: this.auditItemId
          }
          if (this.evidenceTitleModal == 'Objective') {
            Object.assign(form, {
              objective_evidence: []
            })
          }
          if (this.evidenceTitleModal == 'Corrective') {
            Object.assign(form, {
              corrective_evidence: []
            })
          }
          await axios
            .post(`${this.dssApi}audit/item/update_file_upload`, form)
            .then((res) => {
              if (res.data.status_code === '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
              this.loading = false
              setTimeout(() => {
                this.closeEvidenceDialog()
              }, 100)
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog('error', err.message, false)
            })
        }
      })
    },
    readyToDownload(fileLink) {
      window.open(fileLink.file, '_blank')
    },
    uploadFile(event) {
      if (event !== null) {
        if (event.size <= 1024 * 1024 * 2) {
          this.loading = true
          const data = new FormData()
          data.append('file', event)
          data.append('module', 'audit')
          axios
            .post(`${this.uploadApi}esanqua/dss`, data)
            .then((res) => {
              if (res.data.status === true) {
                this.showMsgDialog(
                  'success',
                  'File siap disimpan, Silahkan lanjutkan dengan klik tombol "simpan file"',
                  false
                )
                this.fileName = res.data.data.name
                // setTimeout(() => {
                //   this.submitUploadDoc()
                // }, 200)
              } else {
                this.showMsgDialog('warning', res.data.message, false)
              }
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog('error', err.message, false)
            })
        } else {
          setTimeout(() => {
            this.showMsgDialog('warning', 'Max size = 2MB', false)
            this.fileName = ''
          }, 300)
        }
      } else {
        this.fileName = ''
        // this.$refs.uploadDoc.reset()
      }
    },
    openUploadModal(event) {
      if (event === 'upload') {
        setTimeout(() => {
          this.uploadDialog = true
        }, 500)
      }
      if (event === 'close') {
        if (this.fileName !== '') {
          let fName = ''
          fName = this.fileName
          this.unlinkDokumen(fName, true)
          this.file_subject = null
          // this.$refs.uploadDoc.reset()
        }
        this.$refs.entryFormUpload.reset()
        setTimeout(() => {
          this.uploadDialog = false
        }, 500)
      }
      this.fileName = ''
    },
    submitUploadDoc() {
      this.rules.docRules = [(v) => !!v || 'Tidak ada file yang terupload']
      this.rules.subjectRules = [(v) => !!v || 'Kolom Subject diperlukan']
      const self = this
      setTimeout(function () {
        if (self.$refs.entryFormUpload.validate()) {
          self.updatePhoto(true)
        }
      })
    },
    openCommentDialog(obj) {
      console.log(obj)
      this.commentNote = obj
      setTimeout(() => {
        this.commentDialog = true
      }, 100)
    },
    closeCommentDialog() {
      this.commentDialog = false
      setTimeout(() => {
        this.commentNote = null
      }, 100)
    },
    addMember() {
      this.formMember = {
        act: 'add',
        audit_id: this.detailData.id,
        employee: null,
        scope_ids: null,
        area_ids: null,
        member_type: null
      }
      setTimeout(() => {
        this.formMemberDialog = true
      }, 100)
    },
    closeFormMember() {
      this.formMemberDialog = false
      setTimeout(() => {
        this.formMember = null
      }, 100)
    },
    async memberRowClick(pItem) {
      console.log('memberRowClick', pItem)
      if (
        this.getUserProfile.level.find(
          ({ id }) =>
            id == this.appLevel.adminAudit || id == this.appLevel.administrator
        ) !== undefined
      ) {
        this.formMember = {
          act: 'update',
          id: pItem.id,
          audit_id: this.detailData.id,
          employee: {
            id: pItem.employee_id,
            name: pItem.employee_name,
            nik: pItem.employee_code
          },
          scope_ids: pItem.scope_ids,
          area_ids: pItem.area_ids,
          member_type: pItem.member_type
        }
        console.log(this.formMember)
        this.querySelectionEmployee(pItem.employee_name)
        setTimeout(() => {
          this.formMemberDialog = !this.formDialog
        }, 300)
      }
    },

    saveFormMember() {
      this.rules.employeeRules = [(v) => !!v || 'Employee is required']
      this.rules.memberTypeRules = [(v) => !!v || 'Type is required']
      if (this.detailData.audit_type.id == 1) {
        this.rules.memberScopeRules = [(v) => !!v || 'Scope is required']
      }
      if (this.detailData.audit_type.id == 2) {
        this.rules.memberAreaRules = [(v) => !!v || 'Area is required']
      }
      const self = this
      setTimeout(function () {
        if (self.$refs.entryFormMember.validate()) {
          const form = {
            act: self.formMember.act,
            audit_id: self.formMember.audit_id,
            employee_id: self.formMember.employee.id,
            employee_name: self.formMember.employee.name,
            employee_code: self.formMember.employee.nik,
            scope_ids: self.formMember.scope_ids,
            area_ids: self.formMember.area_ids,
            member_type: self.formMember.member_type
          }
          if (form.act === 'update') {
            Object.assign(form, { id: self.formMember.id })
          }
          console.log(self.formMember)

          self.submitFormMember(form)
        }
      })
    },
    async submitFormMember(form) {
      console.log(form)
      await axios
        .post(`${this.dssApi}audit/member/save`, form)
        .then(async (res) => {
          console.log(res.data)
          if (res.data.status_code !== '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.getDataFromApi()
            this.closeFormMember()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },

    async deleteMember(pItem) {
      this.showMsgDialog(
        'question',
        'Are you sure, This data will be deleted permanently',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          await axios
            .delete(`${this.dssApi}audit/member/delete/${pItem.id}`)
            .then(async (res) => {
              if (res.data.status_code !== '-99') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              console.log(err)
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    async querySelectionEmployee(v) {
      await axios
        .get(`${this.hrsApi}employee/dropdown?keyword=${v}`)
        .then((res) => {
          this.loading = false
          if (res.data.status_code === '00') {
            const resArr = []
            for (let i = 0; i < res.data.data.length; i++) {
              resArr.push({
                id: res.data.data[i].id,
                nik: res.data.data[i].nik,
                name: res.data.data[i].name,
                company_id: res.data.data[i].company_id,
                company_name: this.getCompanyAlias(res.data.data[i].company_id),
                photo: res.data.data[i].photo
              })
            }
            return (this.dropdown.employee = resArr)
          }
          return (this.dropdown.employee = [])
        })
        .catch((err) => {
          this.dropdown.employee = []
          return console.log(err)
        })
    },
    checkIsAdminOrAuditor() {
      // let xFlag = false;
      if (
        this.getUserProfile.level.find(
          ({ id }) =>
            id == this.appLevel.adminAudit || id == this.appLevel.administrator
        ) != undefined
      ) {
        this.isAdminOrAuditor = true
      } else {
        if (
          this.getUserProfile.level.find(
            ({ id }) => id == this.appLevel.picAudit
          ) != undefined
        ) {
          const member = this.detailData.audit_member.find(
            ({ employee_id }) => employee_id == this.getUserProfile.employee.id
          )
          if (member != undefined) {
            this.isAdminOrAuditor = true
          }
        }
      }
      // return xFlag;
    },
    checkIsAuditee() {
      if (
        this.getUserProfile.level.find(
          ({ id }) => id == this.appLevel.picAudit
        ) != undefined
      ) {
        if (
          this.getUserProfile.employee.company.plant_id ==
          this.detailData.company.id
        ) {
          if (
            this.detailData.audit_member.find(
              ({ employee_id }) =>
                employee_id == this.getUserProfile.employee.id
            ) == undefined
          ) {
            this.isAuditee = true
          }
        }
      }
    },
    canAccessItemUpload(tabObj) {
      if (this.detailData.status.id == 2) {
        // dokumen status is in-proggress
        if (this.evidenceTitleModal == 'Objective') {
          if (this.auditItemStatus == 0) {
            // item status is draft
            if (this.isAdminOrAuditor) {
              const member = this.detailData.audit_member.find(
                ({ employee_id }) =>
                  employee_id == this.getUserProfile.employee.id
              )
              if (member != undefined) {
                // console.log('member>>>>', member);
                if (member.member_type == 1) {
                  if (this.detailData.audit_type.id == 1) {
                    if (
                      member.scope_ids.find(
                        (val) => val == tabObj[0].scope.id
                      ) != undefined
                    ) {
                      this.isCanAccessItemUpload = true
                    }
                  } else if (this.detailData.audit_type.id == 2) {
                    if (
                      member.area_ids.find((val) => val == tabObj[0].area.id) !=
                      undefined
                    ) {
                      this.isCanAccessItemUpload = true
                    }
                  }
                } else {
                  this.isCanAccessItemUpload = true
                }
              }
            }
          }
        }

        if (this.evidenceTitleModal == 'Corrective') {
          if (this.auditItemStatus == 1) {
            // item status is in-progress
            if (this.isAuditee) {
              this.isCanAccessItemUpload = true
            }
          }
        }
      }
    },
    checkScheduleArea(obj, i) {
      let isAllow = false
      if (
        this.getUserProfile.level.find(
          ({ id }) =>
            id == this.appLevel.adminAudit || id == this.appLevel.administrator
        ) != undefined
      ) {
        isAllow = true
      } else {
        if (
          this.getUserProfile.level.find(
            ({ id }) => id == this.appLevel.picAudit
          ) != undefined
        ) {
          const member = this.detailData.audit_member.find(
            ({ employee_id }) => employee_id == this.getUserProfile.employee.id
          )
          if (member != undefined) {
            // console.log('member>>>>', member);
            if (member.member_type == 1) {
              if (this.detailData.audit_type.id == 1) {
                if (
                  member.scope_ids.find((val) => val == obj[0].scope.id) !=
                  undefined
                ) {
                  isAllow = true
                }
              } else if (this.detailData.audit_type.id == 2) {
                if (
                  member.area_ids.find((val) => val == obj[0].area.id) !=
                  undefined
                ) {
                  isAllow = true
                }
              }
            } else {
              isAllow = true
            }
          }
        }
      }
      return isAllow
    },
    async updatePage(p) {
      this.paramAPI.page = p
      this.paramAPI.offset = p - 1
      await this.getDataFromApi()
    },
    async updateItemPerPage(p) {
      this.paramAPI.itemsPerPage = p
      this.paramAPI.limit = p
      this.paramAPI.offset = 0
      await this.getDataFromApi()
    },
    convertDate(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      } else {
        return '-'
      }
    },
    statusColor(val) {
      if (val) {
        if (val.id == -1) {
          return 'red'
        } else {
          const arrColour = ['grey', 'orange', 'green', '#4caf50', 'red', 'red']
          return arrColour[val.id]
        }
      }
    },
    itemStatusColor(val) {
      if (val) {
        if (val == -1) {
          return 'red'
        } else {
          const arrColour = ['black', 'green', 'green', 'red', 'red']
          return arrColour[val]
        }
      }
    },
    itemStatusName(val) {
      const arrStatus = ['Draft', 'Progress', 'Verified', 'Cancel', 'Unused']
      return arrStatus[val]
    },
    getCompanyAlias(id) {
      switch (id) {
        case 1:
          return 'TMP'
        case 2:
          return 'IMP'
        case 3:
          return 'GIT'
        case 4:
          return 'KAJ'
        case 5:
          return 'WIM'
        case 6:
          return 'SMI'
        case 7:
          return 'THP'
        case 8:
          return 'GAI'
        case 9:
          return 'GPP'
        case 10:
          return 'BWN'
        case 11:
          return 'INO'
        case 12:
          return 'BPS'
        case 13:
          return 'BPC'
        case 14:
          return 'WIMS'
        case 15:
          return 'BWI'
        case 16:
          return 'DAM'
        case 17:
          return 'PSR'
        case 18:
          return 'GAP'
        case 19:
          return 'SKH'
        case 20:
          return 'PTI'
        case 21:
          return 'BMS'
        case 22:
          return 'SDA'
      }
    },
    getRingkasValue(item) {
      let val = 0
      const obj = item.categories.find(({ category }) => category == 'Ringkas')
      if (obj != undefined) {
        val = obj.total_per_category
      }
      return val
    },
    getRapihValue(item) {
      let val = 0
      const obj = item.categories.find(({ category }) => category == 'Rapi')
      if (obj != undefined) {
        val = obj.total_per_category
      }
      return val
    },
    getResikValue(item) {
      let val = 0
      const obj = item.categories.find(({ category }) => category == 'Resik')
      if (obj != undefined) {
        val = obj.total_per_category
      }
      return val
    },
    getRawatValue(item) {
      let val = 0
      const obj = item.categories.find(({ category }) => category == 'Rawat')
      if (obj != undefined) {
        val = obj.total_per_category
      }
      return val
    },
    getRajinValue(item) {
      let val = 0
      const obj = item.categories.find(({ category }) => category == 'Rajin')
      if (obj != undefined) {
        val = obj.total_per_category
      }
      return val
    },
    getMaintenanceValue(item) {
      let val = 0
      const obj = item.categories.find(
        ({ category }) => category == '5R Mesin & Maintenance'
      )
      if (obj != undefined) {
        val = obj.total_per_category
      }
      return val
    },
    getInterviewValue(item) {
      let val = 0
      const obj = item.categories.find(
        ({ category }) => category == 'Interview 5R'
      )
      if (obj != undefined) {
        val = obj.total_per_category
      }
      return val
    },

    async getDiscoveryItems(param) {
      console.log('getDiscoveryItems >>>', param)

      let url = `${this.dssApi}audit/discoveryitem/list?audit_id=${this.$route.params.id}`
      if (param != null) {
        url = url + `&offset=${param.offset * param.limit}&limit=${param.limit}`

        if (param.keyword != null && param.keyword != '') {
          url = url + `&keyword=${param.keyword}`
        }
        if (param.area != null) {
          url = url + `&area_id=${param.area}`
        }
        if (param.scope != null) {
          url = url + `&scope_id=${param.scope}`
        }
      } else {
        url = url + '&offset=0&limit=10'
      }
      await axios
        .get(url)
        .then((res) => {
          console.log('discoveryData >>>', res)
          if (res.data.status_code == '00') {
            const xResult = res.data.data
            const newArrItem = []

            if (xResult.length > 0) {
              for (let i = 0; i < xResult.length; i++) {
                let corrective_due_date = null
                let corrective_plan_due_date = null
                if (xResult[i].corrective_due_date) {
                  corrective_due_date = moment(
                    xResult[i].corrective_due_date
                  ).format('YYYY-MM-DD')
                }
                if (xResult[i].corrective_plan_due_date) {
                  corrective_plan_due_date = moment(
                    xResult[i].corrective_plan_due_date
                  ).format('YYYY-MM-DD')
                }
                var objItem = {
                  id: xResult[i].id,
                  area: xResult[i].area,
                  scope: xResult[i].scope,
                  description: xResult[i].description,
                  corrective_due_date: corrective_due_date,
                  corrective_evidence: xResult[i].corrective_evidence,
                  corrective_plan_desc: xResult[i].corrective_plan_desc,
                  corrective_plan_due_date: corrective_plan_due_date,
                  objective_evidence: xResult[i].objective_evidence
                }
                newArrItem.push(objItem)
              }
            }
            this.discoveryData = newArrItem
          }
          return null
        })
        .catch((err) => {
          console.log(err)
          return null
        })
    },
    getAreaName(obj) {
      const xFindArea = this.dropdown.area.find((d) => d.id == obj)
      let xAreaName = '-'
      if (xFindArea != undefined) {
        xAreaName = xFindArea.name
      }

      return xAreaName
    },
    getScopeName(obj) {
      const xFindScope = this.dropdown.scope.find((d) => d.id == obj)
      let xScopeName = '-'
      if (xFindScope != undefined) {
        xScopeName = xFindScope.name
      }

      return xScopeName
    }
  }
}
</script>
<style lang="scss">
.actionButton {
  position: relative;
  display: flex;
  // width: 400px;
}
.outer-card {
  border-bottom: 2px solid rgba(0, 0, 0, 0.1) !important;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 60px;
  background: white;
  z-index: 5;

  .doc-no {
    position: absolute;
    bottom: -20px;
    left: 13px;
    font-weight: bold;
    padding-left: 3px;
    font-size: 14px;
  }
  .status-label {
    position: absolute;
    bottom: 2px;
    right: 0;
    border: 1px solid black;

    .status-text {
      color: white;
      font-weight: bold;
      width: 180px;
      text-align: center;
      margin: 0;
    }
  }
}
.created-text {
  position: absolute;
  top: -20px;
  left: 10px;
  font-weight: bold;
  padding-left: 4px;
  font-size: 12px;
}
.column-label {
  margin: 0 !important;
  font-size: 12px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.5);
}
.action-button-1 {
  position: absolute;
  top: -15px;
  right: 0px;
  padding-left: 2px;

  .icon-position {
    position: relative;
    top: 1px;
  }
  .button-status {
    font-weight: bold;
    margin-left: 5px;
  }
}
.action-button-2 {
  position: absolute;
  top: -15px;
  right: 10px;

  .button-cancel {
    font-weight: bold;
    margin-left: 10px;
  }
}
.result-5r {
  padding: 5px;
  table {
    border-collapse: collapse;
    width: 100%;
    text-align: center;
  }

  thead {
    background-color: #f7f7f7;
  }

  th,
  td {
    padding: 6px 12px;
  }

  td:first-child {
    font-weight: bold;
    text-align: left;
  }
}
@media (max-width: 768px) {
}
</style>
